import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import CartIdDetailsSection from "./PrescribedDiagnosticsComponents/CartIdDetailsSection";
import UserDetailsSection from "./PrescribedDiagnosticsComponents/UserDetailsSection";
import DocCartView from "./PrescribedDiagnosticsComponents/DocCartView";
import PaymentDetailsSection from "./PrescribedDiagnosticsComponents/PaymentDetailsSection";
import { Row, Col } from "react-flexbox-grid";
import { Button, DialogContainer, SelectField, TextField } from "react-md";
import FontIcon from "react-md/lib/FontIcons";
import "./../styles/PrescribedDiagnosticsStyles.scss";
import NavigoDashboardUtils from "../../navigo-module/services/NavigoDashboardUtils";
import CartDashboardUtils, {
  DOCUMENT_FOLDER_MEDICAL_RECORDS,
  DOCUMENT_FOLDER_OTHER_MEDIA,
} from "../services/CartDashboardUtils";
import EventService from "../../../../../service/event/EventService";
import PatientsService from "../../../../ops/modules/patients/service/PatientsService";
import debounce from "debounce";
import SimpleBackdrop from "../../service-module/helper/SimpleBackdrop";

import {
  LOCATION_MODE,
  SERVICE_TYPE,
  SERVICE_SUB_TYPE,
  MODES,
  LOCATION_BASED_MODES,
  MODES_WITH_AUTO_SP,
} from "../../navigo-module/helper/appointmentConstants";
import moment from "moment";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import SelectDateSlotSection from "./PrescribedDiagnosticsComponents/SelectDateSlotSection";
import MarkOnHoldDialog from "./PrescribedDiagnosticsComponents/MarkOnHoldDialog";
import MarkOnHoldSuccessDialog from "./PrescribedDiagnosticsComponents/MarkOnHoldSuccessDialog";
import RejectOrderDialog from "./PrescribedDiagnosticsComponents/RejectOrderDialog";
import RejectOrderSuccessDialog from "./PrescribedDiagnosticsComponents/RejectOrderSuccessDialog";
import {
  CART_STATUS_DRAFT,
  CART_STATUS_PENDING_REVIEW,
  CART_STATUS_ON_HOLD,
  CART_STATUS_REJECTED,
  CART_STATUS_SUCCESS,
  CART_STATUS_PENDING_TOPUP,
  CART_STATUS_CANCELLED,
  hasFrozenPrices,
  PLAN_STATUS_ACTIVE,
  PLAN_STATUS_INACTIVE,
  PLAN_STATUS_UPCOMING,
  PLAN_STATUS_EXPIRED,
} from "../constants/cart-constants";
import CartPaymentDetailsDialog from "./PrescribedDiagnosticsComponents/CartPaymentDetailsDialog";
import CartPaymentLinkDialog from "./PrescribedDiagnosticsComponents/CartPaymentLinkDialog";
import {
  LocationSearchDialog,
  useLocationDialog,
} from "../../navigo-module/helper/useLocationDialog";
import { useConfirmDialog } from "../../account-module/helper/useConfirmDialog";
import { useAddressFlow } from "../../../../ops/modules/patients/modules/new-bridge/components/GeoAddress/useAddressFlow";
import AddressFlowDialog from "../../../../ops/modules/patients/modules/new-bridge/components/GeoAddress/AddressFlowDialog";
import NavigoAPIServices from "../../navigo-dashboard/services/navigoAPIServices";

const PrescribedDiagnosticsScreen = (props) => {
  const [loading, setLoading] = useState(false);
  const [totalModes, setTotalModes] = useState([]);
  const [patientIdList, setPatientIdList] = useState([]);
  // Seeded from the host, which re-keys this screen on the selected patient (see selectPatient
  // and index.js). On a patient change the component is a brand-new mount, so this is the only
  // place the patient enters the tree.
  const [patientDetails, setPatientDetails] = useState(
    props.initialPatient ?? null,
  );
  const [accountList, setAccountList] = useState([]);
  const [accountSelected, setAccountSelected] = useState(null);
  const [planList, setPlanList] = useState([]);
  const [planSelected, setPlanSelected] = useState(null);
  const [serviceTypeList, setServiceTypeList] = useState([]);
  const [serviceTypeSelected, setServiceTypeSelected] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [serviceListToShow, setServiceListToShow] = useState([]);
  const [serviceSelected, setServiceSelected] = useState(null);
  // Why the group-service dropdown is empty, when it should not be. Null while
  // the field is fine (or simply not ready yet); a message once a completed
  // fetch yielded nothing selectable. Rendered under the field and, because the
  // operator cannot fix this themselves, also toasted once per fetch.
  const [groupServiceError, setGroupServiceError] = useState(null);
  // Same contract for the plan field: set when opening a cart could not restore its plan —
  // typically because the plan expired after the cart was raised.
  const [planError, setPlanError] = useState(null);
  const [serviceModeList, setServiceModeList] = useState([]);
  const [serviceModeSelected, setServiceModeSelected] = useState(null);
  const [familyMemberList, setFamilyMemberList] = useState([]);
  const [selectedFamilyMember, setSelectedFamilyMember] = useState(null);
  const [relationsList, setRelationsList] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [addressSelected, setAddressSelected] = useState(null);
  // Scoped to the address dropdown's own re-fetch, separate from the screen-wide `loading`
  // (which disables the field entirely and would close the menu the operator just opened).
  const [addressLoading, setAddressLoading] = useState(false);
  // True while a serviceability check is in flight. The vendor-manager fans out serially over
  // every cart-enabled vendor, so this is slow enough that the dropdown must be locked meanwhile.
  const [addressCheckLoading, setAddressCheckLoading] = useState(false);
  // Verdict of a LIVE serviceability check. null = never checked (every cart the on-open
  // re-check does not apply to, and every screen before the operator picks an address) — that
  // is the pre-existing behaviour and renders exactly as before. true / false only ever come
  // from an actual /service/check response.
  const [addressServiceable, setAddressServiceable] = useState(null);
  const [loadingProfileUpdate, setLoadingProfileUpdate] = useState(false);
  const [patientInfo, setPatientInfo] = useState(null);
  const [newDob, setNewDob] = useState(null);
  const [newEmail, setNewEmail] = useState("");
  const [updatePatientInfoDialog, setUpdatePatientInfoDialog] = useState(false);
  // Seeded from the same source as patientDetails: the picker sets both together, but the
  // patient change remounts this screen, so a setter call on the outgoing instance is lost.
  const [patientContactNumber, setPatientContactNumber] = useState(
    props.initialPatient?.phoneno ?? null,
  );
  const [openSelectDateSlot, setOpenSelectDateSlot] = useState(false);

  // ---- Cart flow state ----
  const [documentsList, setDocumentsList] = useState([]);
  // The ACCOUNT HOLDER's copies of the same files, as bare ids — never rendered, so there is
  // nothing to fetch. Kept index-for-index with documentsList (a 0 means "this file has no
  // account-holder copy": a legacy document, or one uploaded while the cart was for the account
  // holder). That alignment is what lets a delete drop both halves of the same file.
  const [primaryMemberDocumentIds, setPrimaryMemberDocumentIds] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [cartConfirmed, setCartConfirmed] = useState(false);
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [slotData, setSlotData] = useState({ dates: [], slots: {} });
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [cartLoading, setCartLoading] = useState(false);
  const [docToken, setDocToken] = useState("");
  // createdCartId holds the DRAFT cart id (from modifyActiveCart) so the
  // CREATE / EDIT-DRAFT flow can run the same admin sublimit + approve calls as
  // VERIFY, which already has initialCartData.id.
  const [createdCartId, setCreatedCartId] = useState(null);
  // Whether the selected plan has wallet enabled. The cart's planSelected
  // (PlanAppResponse) does NOT carry walletDetails, so this is fetched by planId from the
  // plans/filters API. Wallet plans require a prescription document before booking.
  const [planWalletIncluded, setPlanWalletIncluded] = useState(false);
  // The relation codes the plan lets the wallet be spent on (walletDetails.
  // allowedFamilyRelations). Comes back from the same plans/filters call as
  // planWalletIncluded. Relation 0 (self) is never listed and never needs to be.
  const [planAllowedFamilyRelations, setPlanAllowedFamilyRelations] = useState(
    [],
  );
  // ---- Cart payment-preview / approve flow ----
  const [cartPaymentPreview, setCartPaymentPreview] = useState(null);
  const [showCartPaymentDialog, setShowCartPaymentDialog] = useState(false);
  const [showCartPaymentLinkDialog, setShowCartPaymentLinkDialog] =
    useState(false);
  const [cartPaymentLoading, setCartPaymentLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(
    props.data?.mode !== "CREATE" && props.data?.mode != null,
  );
  const [initialCartData, setInitialCartData] = useState(null);
  const [cartEventHistory, setCartEventHistory] = useState([]);
  // ---- Frozen price break-up (booked carts only) ----
  // A booked cart's prices were frozen on its head cart_payment_request at approve/payment time.
  // They are the source of truth for what the patient paid, so they must not be overwritten by the
  // live provider re-price that drives the DRAFT/verify flow. `priceRows` holds the priced services
  // that are not cart items (the home-sample collection charge); `priceTotal` is the booked total.
  // The ref mirrors the serviceId -> price map so handleSelectProvider can consult it without
  // re-running on every render.
  const frozenPricesRef = useRef(null);
  const [priceRows, setPriceRows] = useState([]);
  const [priceTotal, setPriceTotal] = useState(null);
  // Mark-on-hold flow: the reason dialog opens first; on a successful POST
  // /hold the success dialog opens. Resume from the success dialog flips
  // back to PENDING_REVIEW and closes; Done exits the screen with a refresh.
  const [showMarkOnHoldDialog, setShowMarkOnHoldDialog] = useState(false);
  const [showMarkOnHoldSuccessDialog, setShowMarkOnHoldSuccessDialog] =
    useState(false);
  // True while the header's Resume CTA has a POST /resume in flight — disables
  // the button so a double-click can't fire two requests.
  const [resuming, setResuming] = useState(false);
  // Reject-order flow: reason dialog → success dialog. Done returns to the
  // dashboard with a refresh; Reorder hands off to handleReorder (which closes
  // this dialog first and re-opens it if the operator backs out).
  const [showRejectOrderDialog, setShowRejectOrderDialog] = useState(false);
  const [showRejectOrderSuccessDialog, setShowRejectOrderSuccessDialog] =
    useState(false);
  const mode = props.data?.mode || "CREATE";
  const autoSelectRef = useRef(mode !== "CREATE");
  // The cart's plan record from the plans/filters lookup in resolveAccountCode. The patient's
  // plan list (getPlansForPid) is active-only, so an expired plan is simply absent from it;
  // this record is what lets a stalled hydration say why.
  const cartPlanRef = useRef(null);
  // "Add New": tracks the last PID we already auto-populated a DRAFT for, so the
  // patient-driven fetch fires once per selected patient (not on every re-render).
  const draftHydratedPidRef = useRef(null);
  // The patient currently on screen. Every patient-scoped fetch below captures the PID it was
  // issued for and checks it against this before applying its response, because a response
  // that lands after the operator has cleared or changed the PID belongs to someone else:
  // applying it would repopulate the screen with the previous patient's cart, documents and
  // family — the exact leak clearing the PID exists to prevent. Kept in a ref, not state, so
  // the callbacks read the live value rather than the one captured at request time.
  const activePidRef = useRef(null);

  // The patient the booking is FOR — the "Booking for" member, which is the primary patient
  // himself when "Self" is picked. Address fetches are scoped to this, not to activePidRef,
  // and follow the same capture-and-compare rule: switching member mid-flight must not let
  // the previous member's addresses land in the dropdown.
  const activeBookingForPidRef = useRef(null);

  // Mirrors the app's _addressCheckSeq. Every serviceability request captures the counter it
  // was issued under; a verdict whose counter no longer matches belongs to an address the
  // operator has already moved off, and acting on it would block (or unblock) the wrong one.
  const addressCheckSeqRef = useRef(0);
  // The on-open re-check is a one-shot per mount — without this it would re-fire on every
  // render that touches addressSelected (including the one its own setState causes).
  const openRecheckDoneRef = useRef(false);

  // The parent "group service" id every cart payload requires (the backend
  // rejects a zero groupServiceId). CREATE sources it from the service the user
  // picks; VERIFY / EDIT-DRAFT fall back to the value already on the fetched
  // cart (also used to auto-select the service dropdown below).
  const groupServiceId =
    serviceSelected?.serviceId ?? initialCartData?.groupServiceId ?? null;

  // ---- Status-driven edit permissions ----
  // A cart is editable only while it is a DRAFT (status 1, EDIT-DRAFT) or
  // PENDING_REVIEW (status 2, VERIFY). CREATE has no cart yet (status null) and
  // is fully editable. Any later status (on hold / rejected / success / …)
  // makes the whole screen read-only. VIEW-ONLY is read-only by mode regardless
  // of status — the dashboard opens terminal carts in this mode, and keying off
  // the prop (not just the fetched status) makes the screen render read-only
  // immediately, before initialCartData loads.
  const isViewOnly = mode === "VIEW-ONLY";
  const cartStatus = initialCartData?.status ?? null;
  // A terminal cart opened read-only (VIEW-ONLY) can be re-ordered: clone it
  // into a fresh DRAFT and open that. Only the genuinely-finished states qualify
  // (rejected / successful / pending top-up / cancelled) — not an in-flight
  // pending-review/on-hold cart, which is still actionable via its own buttons.
  const canReorder =
    isViewOnly &&
    [
      CART_STATUS_REJECTED,
      CART_STATUS_SUCCESS,
      CART_STATUS_PENDING_TOPUP,
      CART_STATUS_CANCELLED,
    ].includes(cartStatus);
  const isCartReadOnly =
    isViewOnly ||
    (cartStatus != null &&
      cartStatus !== CART_STATUS_DRAFT &&
      cartStatus !== CART_STATUS_PENDING_REVIEW);
  // In VERIFY the cart's identity is frozen — the reviewer can adjust the
  // booking (tests, provider, slot) but not re-point who or what it is for:
  // patient / account / plan / service type / booking-for member / address. A
  // read-only cart locks these (and everything else) too, so this covers the
  // whole User-details section: it is editable only on a DRAFT or in CREATE.
  const lockIdentityFields =
    cartStatus === CART_STATUS_PENDING_REVIEW || isCartReadOnly;

  // The single way the selected patient ever changes.
  //
  // In CREATE the host (index.js) owns the patient and uses it as this screen's React key, so
  // picking or clearing a PID REMOUNTS the whole screen. That remount — not a careful sweep of
  // ~30 setters — is what guarantees nothing of the previous patient survives: documents, cart
  // id, provider list, slot data, frozen prices and every useRef go with it. resetValues(1) is
  // kept as defence in depth, and is still the only mechanism in the non-CREATE modes, where
  // the patient is fixed and no re-key happens.
  //
  // Hydration in EDIT-DRAFT / VERIFY deliberately does NOT route through here: there the
  // patient comes from the cart being opened, and re-keying on it would remount the screen
  // mid-cascade.
  const selectPatient = (patient) => {
    setPatientDetails(patient);
    if (mode === "CREATE" && typeof props.onPatientChange === "function") {
      props.onPatientChange(patient);
    }
  };

  const navigoDashboardUtils = new NavigoDashboardUtils();
  const cartDashboardUtils = new CartDashboardUtils();
  const patientService = new PatientsService();
  const navigoAPIServices = new NavigoAPIServices();

  // The cart module only ever books HEALTH_CHECKUP services, so the "Select
  // service type" dropdown is restricted to that single option (sourced from
  // totalModes so the label matches the rest of the app). The plan must still
  // actually allow health checkups, otherwise the dropdown is empty. Both the
  // CREATE plan-change effect and the non-CREATE auto-select cascade use this.
  const buildServiceTypeList = (plan) => {
    if (!plan?.bookHealthCheckup) return [];
    const healthCheckupMode = totalModes.find(
      (e) => e.id === SERVICE_TYPE.HEALTH_CHECKUP,
    );
    if (!healthCheckupMode) return [];
    return [
      {
        serviceTypeId: healthCheckupMode.id,
        serviceTypeName: healthCheckupMode.name,
      },
    ];
  };

  const exitScreen = () => {
    props.setView(0);
  };

  useEffect(() => {
    getModes();
    getAllRelation();
    generateDocumentToken();
    if (mode !== "CREATE" && props.data?.cartId) {
      fetchCartDetails(props.data.cartId);
    }
  }, []);

  const fetchCartDetails = (cartId) => {
    // VERIFY open: ask the backend to first reset the cart fields from the head
    // cart_payment_request snapshot, so each verify session starts from the app
    // user's original submission rather than whatever the reviewer left behind
    // on a prior visit. (EDIT-DRAFT / VIEW-ONLY read the cart as-is.)
    //
    // For any non-CREATE open we also pass `includeEvents` so the screen can
    // render the Payment details table from the cart's hydrated, append-only log
    // of payment / refund events. The response is the same flat cart doc with an
    // extra `eventHistory` field merged in; callers that don't pass the flag
    // (dashboard) get the same flat cart with no `eventHistory`.
    //
    // `includePrices` brings back the cart's frozen per-service price break-up
    // (`serviceBreakup`). Only a booked cart has one; it is what the patient actually
    // paid, so it — not a live re-price — is what a booked cart must display.
    const opts = {
      syncFromHead: mode === "VERIFY",
      includeEvents: true,
      includePrices: true,
    };
    cartDashboardUtils.fetchCartById(
      cartId,
      (res) => {
        if (res) {
          const eventHistory = Array.isArray(res.eventHistory)
            ? res.eventHistory
            : [];
          setCartEventHistory(eventHistory);
          resolveAccountCode(res);
        } else {
          autoSelectRef.current = false;
          setInitialLoading(false);
          EventService.emit("showError", {
            message: "Cart not found",
          });
        }
      },
      (err) => {
        autoSelectRef.current = false;
        setInitialLoading(false);
        EventService.emit("showError", {
          message: `Error fetching cart: ${err?.message}`,
        });
      },
      opts,
    );
  };

  // The real cart-by-id API does not return accountCode, so derive it from the
  // cart's planId via the plans/filters API before starting the auto-select
  // cascade (which matches accountCode against the patient's accounts).
  const resolveAccountCode = (cart) => {
    // Every cart in this module is a HEALTH_CHECKUP cart, so stamp the service
    // type on the loaded cart unconditionally. The auto-select cascade then
    // matches it against the (HEALTH_CHECKUP-only) serviceTypeList.
    const cartWithServiceType = {
      ...cart,
      serviceTypeId: SERVICE_TYPE.HEALTH_CHECKUP,
    };
    if (cart.accountCode || !cart.planId) {
      setInitialCartData(cartWithServiceType);
      return;
    }
    cartDashboardUtils.fetchAccountCodeByPlanId(
      cart.planId,
      (accountCode, plan) => {
        cartPlanRef.current = plan;
        if (accountCode) {
          setInitialCartData({ ...cartWithServiceType, accountCode });
        } else {
          autoSelectRef.current = false;
          setInitialLoading(false);
          EventService.emit("showError", {
            message: `Account code not found for plan ${cart.planId}`,
          });
        }
      },
      (err) => {
        autoSelectRef.current = false;
        setInitialLoading(false);
        EventService.emit("showError", {
          message: `Error fetching account code: ${err?.message}`,
        });
      },
    );
  };

  // Ends the auto-select cascade early. Each step waits on the one before it and only the
  // last one drops the backdrop, so a step that cannot continue has to drop it itself —
  // otherwise the screen sits behind the spinner forever with every API call green.
  const abortAutoSelect = (message) => {
    autoSelectRef.current = false;
    setInitialLoading(false);
    if (message) EventService.emit("showError", { message });
  };

  // Why the cart's plan cannot be restored, when its own record says so; null when the plan
  // is active or the record never loaded. A prescription cart can sit in review for days, and
  // nothing moves it when its plan ends underneath it.
  const lapsedPlanMessage = () => {
    const plan = cartPlanRef.current;
    const status = plan?.basicDetails?.status;
    if (status == null || status === PLAN_STATUS_ACTIVE) return null;
    const reason =
      {
        [PLAN_STATUS_EXPIRED]: "has expired",
        [PLAN_STATUS_INACTIVE]: "is inactive",
        [PLAN_STATUS_UPCOMING]: "has not started yet",
      }[status] ?? "is not active";
    const name = plan.basicDetails.name ? ` "${plan.basicDetails.name}"` : "";
    return `This cart's plan${name} (${plan.id}) ${reason}.`;
  };

  // Hydration could not restore the cart's account or plan. Whichever step tripped, a lapsed
  // plan is the real reason when its record says so. `pin` also shows the message under the
  // Plan field — that field is locked in VERIFY, so left empty it looks like it is still loading.
  const failPlanHydration = (fallbackMessage, { pin = false } = {}) => {
    const lapsed = lapsedPlanMessage();
    const message = lapsed ?? fallbackMessage;
    if (lapsed || pin) setPlanError(message);
    abortAutoSelect(message);
  };

  // Pads/truncates the account-holder copies to line up index-for-index with the cart's own
  // document ids. A 0 fills any file that has no second copy — legacy documents uploaded before
  // the two-copy scheme, or files added while the cart was booked for the account holder. The
  // backend drops non-positive ids when it flattens the two lists onto the appointment, so a
  // placeholder is inert everywhere except here, where it keeps the indexes honest.
  const alignPrimaryDocumentIds = (mainIds, primaryIds) =>
    (Array.isArray(mainIds) ? mainIds : []).map((_, i) =>
      Array.isArray(primaryIds) ? (primaryIds[i] ?? 0) : 0,
    );

  // Replaces the document panel with exactly the cart's documents. An empty/absent id list
  // CLEARS the panel rather than returning early — otherwise a cart with no documents would
  // silently inherit whichever documents happened to be on screen already.
  // `pid` is the patient these documents belong to, captured by the CALLER at dispatch time.
  // Every other fetch on this screen already guards on activePidRef; this one did not, and it
  // is the one that writes the document panel. The N getDocuments calls below are slow enough
  // to outlive a PID change, so without the check a late response repaints the PREVIOUS
  // patient's prescriptions under the newly selected one — and handleUploadDocument then sends
  // that list back as the new patient's prescriptionDocumentIds. The backend does not validate
  // document ownership, so this guard is load-bearing, not cosmetic.
  const fetchCartDocuments = async (documentIds, pid, primaryIds = []) => {
    const applyIfStillCurrent = (docs, selected) => {
      if (pid != null && activePidRef.current !== pid) return;
      setDocumentsList(docs);
      // Written under the same guard for the same reason: sent back on the next upload as
      // primaryMemberDocumentIds, a late response would hand one patient's copies to another.
      setPrimaryMemberDocumentIds(
        alignPrimaryDocumentIds(documentIds, primaryIds),
      );
      setSelectedDocument(selected);
    };

    if (!Array.isArray(documentIds) || documentIds.length === 0) {
      applyIfStillCurrent([], null);
      return;
    }
    try {
      const docs = await Promise.all(
        documentIds.map((docId) => {
          return new Promise((resolve, reject) => {
            navigoAPIServices.getDocuments(
              docId,
              (res) => resolve(res),
              (err) => {
                console.error(`Error fetching document ID ${docId}:`, err);
                reject(err);
              },
            );
          });
        }),
      );
      applyIfStillCurrent(docs, docs.length > 0 ? docs[0] : null);
    } catch (error) {
      console.error("Error fetching cart documents:", error);
    }
  };

  // Start auto-selection cascade when initialCartData is fetched
  useEffect(() => {
    if (mode !== "CREATE" && initialCartData?.patientId) {
      navigoDashboardUtils.fetchPatientId(
        initialCartData.patientId,
        (res) => {
          if (res && res.id !== undefined) {
            setPatientDetails(res);
            setPatientContactNumber(res.phoneno);
            getAccountsForPid(res.id);
            getFamilyMembers(res.id);
          } else {
            autoSelectRef.current = false;
            setInitialLoading(false);
            EventService.emit("showError", {
              message: "Patient not found",
            });
          }
        },
        (err) => {
          autoSelectRef.current = false;
          setInitialLoading(false);
          EventService.emit("showError", {
            message: `Error fetching patient: ${err?.message}`,
          });
        },
      );
    }
  }, [initialCartData]);

  const generateDocumentToken = () => {
    patientService.getAndSaveDocumentToken(
      (response) => {
        localStorage.setItem("zy.bridge.doc.token", JSON.stringify(response));
        setDocToken(response.token);
      },
      (error) => {},
    );
  };

  useEffect(() => {
    // Declared above the fetch effects so the ref is current before any of them issue a
    // request, and updated on clear (id -> null) so in-flight responses for the outgoing
    // patient are dropped rather than applied to whoever comes next.
    activePidRef.current = patientDetails?.id ?? null;
    if (patientDetails != null && patientDetails.id) {
      getAccountsForPid(patientDetails.id);
      getFamilyMembers(patientDetails.id);
    }
  }, [patientDetails]);

  // Mirrors the "Booking for" selection into a ref for the same reason as activePidRef:
  // address fetches must compare against the live member, not the one captured at
  // request time. Kept beside the selection rather than inside the handlers so the
  // hydration path (which sets the member programmatically) is covered too.
  useEffect(() => {
    activeBookingForPidRef.current =
      selectedFamilyMember?.memberPatientId ?? null;
    // Any address fetch still in flight is now for the outgoing member, and the guard in
    // its callback will drop it — so nothing else would ever turn the spinner off.
    setAddressLoading(false);
  }, [selectedFamilyMember]);

  // "Add New" auto-populate: when the operator picks a Patient ID in CREATE mode,
  // load that patient's existing DRAFT cart (the single DRAFT shared with the app)
  // and, if one exists, hydrate the form from it by reusing the same
  // initialCartData-driven auto-select cascade as EDIT-DRAFT. No DRAFT → stay in a
  // fresh manual create flow. The ref guard makes this fire once per patient.
  useEffect(() => {
    if (mode !== "CREATE") return;
    const pid = patientDetails?.id;
    if (!pid || draftHydratedPidRef.current === pid) return;
    draftHydratedPidRef.current = pid;
    cartDashboardUtils.fetchActiveCartByPatientId(
      pid,
      (res) => {
        // The operator cleared or changed the PID while this was in flight: hydrating now
        // would restore this cart — and its documents — under whoever is selected next.
        if (activePidRef.current !== pid) return;
        const cart = res?.cart ?? res;
        // cart.id === 0 / absent means the patient has no DRAFT.
        if (cart && cart.id) {
          autoSelectRef.current = true;
          // resolveAccountCode → setInitialCartData kicks off the cascade; the
          // account/family lists are already loading from the effect above. The
          // account- and family-match effects also depend on initialCartData, so
          // they re-evaluate when the DRAFT lands even if the lists arrived first.
          resolveAccountCode(cart);
        }
      },
      (err) => {
        // No draft / fetch failed — continue with the empty manual create flow.
        console.warn("Add New: no existing draft to hydrate", err?.message);
      },
    );
  }, [patientDetails?.id, mode]);
  useEffect(() => {
    if (accountSelected != null && accountSelected != "") {
      getPlansForPid(patientDetails.id, accountSelected);
    }
  }, [accountSelected]);

  useEffect(() => {
    if (planSelected != null) {
      setLoading(true);
      setServiceTypeList(buildServiceTypeList(planSelected));
      setLoading(false);
    }
  }, [planSelected]);

  // Fetch the selected plan's wallet rules — planSelected (PlanAppResponse) doesn't carry
  // walletDetails, so they're derived by planId. Used to enforce the "wallet plans require
  // a prescription document before booking" rule, and to tell the operator up front when
  // the wallet cannot be used for the family member the cart is booked for.
  useEffect(() => {
    const planId = planSelected?.planId;
    if (!planId) {
      setPlanWalletIncluded(false);
      setPlanAllowedFamilyRelations([]);
      return;
    }
    cartDashboardUtils.fetchPlanWalletRulesByPlanId(
      planId,
      (rules) => {
        setPlanWalletIncluded(rules?.isWalletIncluded === true);
        setPlanAllowedFamilyRelations(rules?.allowedFamilyRelations ?? []);
      },
      () => {
        setPlanWalletIncluded(false);
        setPlanAllowedFamilyRelations([]);
      },
    );
  }, [planSelected?.planId]);

  // Whether the Zyla wallet is off the table because of who the cart is booked for.
  //
  // Derived client-side from the "Booking for" dropdown rather than read off the cart, so
  // the notice tracks the operator's selection immediately — before anything is saved and
  // without a round trip. The equivalent check runs server-side in cart-service
  // (helpers.EvaluateWalletFamilyGate) and is what actually enforces the rule.
  //
  // The backend verdict wins when we have one: /payment-sublimit also applies
  // EXCLUDE_WALLET_CONFIG (per-plan service-type blocks), which is not exposed to the client
  // and so cannot be reproduced here.
  const walletBlockedByRelation = (() => {
    if (!planWalletIncluded) return false;
    const relation = selectedFamilyMember?.relation;
    // relation 0 is the account holder; null/undefined means "not chosen yet", and claiming
    // a block before a member is picked would be noise.
    if (relation == null || relation === 0) return false;
    return !planAllowedFamilyRelations.includes(relation);
  })();
  const walletBlockedForMember =
    cartPaymentPreview?.sublimit?.walletBlockedForMember === true ||
    walletBlockedByRelation;
  const walletBlockedMessage =
    cartPaymentPreview?.sublimit?.walletBlockedMessage ||
    "Zyla wallet can't be used for this family member.";

  useEffect(() => {
    if (selectedFamilyMember == null) {
    } else {
      getFamilyDetails();
    }
  }, [selectedFamilyMember]);

  // ---- EDIT-DRAFT auto-selection cascade ----
  // Auto-select account when accountList is populated
  useEffect(() => {
    if (
      autoSelectRef.current &&
      accountList.length > 0 &&
      initialCartData?.accountCode
    ) {
      const match = accountList.find(
        (acc) => acc === initialCartData.accountCode,
        // (acc) => acc === "01XXDC",
      );
      if (match) {
        setAccountSelected(match);
      } else {
        failPlanHydration(
          `Account "${initialCartData.accountCode}" not found for this patient`,
        );
      }
    }
    // initialCartData is in the deps so this re-evaluates in the "Add New" flow,
    // where the patient (and thus accountList) is selected before the DRAFT loads.
  }, [accountList, initialCartData]);

  // Auto-select plan when planList is populated
  useEffect(() => {
    if (
      autoSelectRef.current &&
      planList.length > 0 &&
      initialCartData?.planId
    ) {
      const match = planList.find((p) => p.planId === initialCartData.planId);
      if (match) {
        setPlanSelected(match);

        const types = buildServiceTypeList(match);
        setServiceTypeList(types);
        // The service-type effect below only runs on a non-empty list, so a plan that
        // books no health checkups would otherwise stall the cascade right here.
        if (types.length === 0) {
          failPlanHydration(
            match.bookHealthCheckup
              ? "Could not load service types. Please reopen the cart."
              : `Plan "${match.name}" (${match.planId}) doesn't include health checkups`,
            { pin: true },
          );
        }
      } else {
        failPlanHydration(
          `Plan "${initialCartData.planId}" not found or inactive for this patient`,
          { pin: true },
        );
      }
    }
  }, [planList]);

  // Auto-select service type when serviceTypeList is populated
  useEffect(() => {
    if (
      autoSelectRef.current &&
      serviceTypeList?.length > 0 &&
      initialCartData?.serviceTypeId
    ) {
      const match = serviceTypeList.find(
        (st) => st.serviceTypeId === initialCartData.serviceTypeId,
        // (st) => st.serviceTypeId === 1,
      );
      if (match) {
        setServiceTypeSelected(match);
      } else {
        autoSelectRef.current = false;
        setInitialLoading(false);
        EventService.emit("showError", {
          message: "Service type not available for this plan",
        });
      }
    }
  }, [serviceTypeList]);

  // Auto-select family member when familyMemberList is populated
  useEffect(() => {
    if (
      autoSelectRef.current &&
      familyMemberList.length > 0 &&
      initialCartData
    ) {
      const bookedForId =
        initialCartData.bookedFor ?? initialCartData.familyMemberId;
      if (bookedForId != null) {
        const targetId = bookedForId === 0 ? patientDetails?.id : bookedForId;
        const match = familyMemberList.find(
          (fm) => fm.memberPatientId === targetId,
        );
        if (match) {
          setSelectedFamilyMember(match);
        } else {
          autoSelectRef.current = false;
          setInitialLoading(false);
          EventService.emit("showError", {
            message: "Family member not found",
          });
        }
      }
    }
    // initialCartData is in the deps so this re-evaluates in the "Add New" flow,
    // where the patient (and thus familyMemberList) is selected before the DRAFT loads.
  }, [familyMemberList, initialCartData]);

  // Reconcile the document panel to whatever the CURRENTLY selected patient's cart holds.
  //
  // This deliberately lives outside the auto-select cascade. It used to run inside
  // finishAutoSelect, which is gated on autoSelectRef — and in CREATE mode autoSelectRef only
  // becomes true when the newly picked patient turns out to HAVE a draft. So selecting a
  // patient with no draft never reconciled, and the previous patient's documents stayed on
  // screen. Keying on the patient (not on the cart) means "no cart" is a first-class case that
  // empties the panel, which is the behaviour we actually want.
  useEffect(() => {
    const pid = patientDetails?.id;
    if (!pid) return; // PID cleared → resetPatientDerivedState already emptied the panel
    fetchCartDocuments(
      initialCartData?.prescriptionDocumentIds ?? [],
      pid,
      initialCartData?.primaryMemberDocumentIds ?? [],
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientDetails?.id, initialCartData?.id]);

  // Auto-select address (final step of cascade)
  useEffect(() => {
    if (
      autoSelectRef.current &&
      selectedFamilyMember &&
      serviceTypeSelected &&
      patientDetails
    ) {
      autoSelectRef.current = false; // Prevent re-entry

      const finishAutoSelect = () => {
        // Load cart items and providers if serviceIds exist
        if (
          initialCartData?.serviceIds &&
          initialCartData.serviceIds.length > 0
        ) {
          setCartLoading(true);
          cartDashboardUtils.fetchChildServicesByIds(
            initialCartData.serviceIds,
            {
              planId: initialCartData.planId,
              patientId: initialCartData.patientId,
              groupServiceId: initialCartData.groupServiceId,
            },
            (tests) => {
              let hydrated = tests.map((t) => ({ ...t, available: true }));

              // A booked cart shows the prices it was booked at, not a live re-price. Stamp them
              // from the frozen break-up and record them so handleSelectProvider (which still runs
              // below, to resolve the provider) cannot clobber them with coverage prices.
              if (hasFrozenPrices(initialCartData?.status)) {
                const { items, extraRows, total } =
                  cartDashboardUtils.applyServiceBreakup(
                    hydrated,
                    initialCartData?.serviceBreakup,
                  );
                hydrated = items;
                frozenPricesRef.current = new Map(
                  items.map((item) => [item.id, item.price]),
                );
                setPriceRows(extraRows);
                setPriceTotal(total);
              }
              setCartItems(hydrated);

              // Only open the confirmed (provider-selected) view when the cart actually
              // has a PERSISTED provider. An app-built DRAFT never persists a provider
              // (serviceProviderId 0 — the app re-fetches it fresh each visit), so open it
              // in modify-cart mode instead of auto-selecting a bogus first provider. Carts
              // with a real provider (e.g. PENDING_REVIEW after payment) show confirmed.
              const targetProviderId = initialCartData.serviceProviderId;
              if (!targetProviderId) {
                setCartConfirmed(false);
                setCartLoading(false);
                setInitialLoading(false);
                return;
              }

              // Auto-confirm cart by fetching providers
              const providerBody = {
                patientId: initialCartData.patientId,
                planId: initialCartData.planId,
                groupServiceId: initialCartData.groupServiceId,
                serviceIds: initialCartData.serviceIds,
                addressId: initialCartData.addressId,
                // Read off the cart rather than selectedFamilyMember, like every other
                // field here — the cart's own record of who it is for is what the app
                // judged eligibility against. Same fallback the auto-select effect uses.
                bookedFor:
                  initialCartData.bookedFor ?? initialCartData.familyMemberId,
              };
              cartDashboardUtils.fetchProviders(
                providerBody,
                (res) => {
                  const providerList = res.providers || [];
                  setProviders(providerList);

                  // Select the provider persisted on the cart. If it is no longer in the
                  // available list, leave the dropdown UNSELECTED — do NOT auto-pick another
                  // provider, so the reviewer consciously re-chooses instead of silently
                  // booking a different provider than the backend recorded.
                  const match = providerList.find(
                    (p) => p.id === targetProviderId,
                  );
                  if (match) {
                    handleSelectProvider(match);
                  }

                  setCartConfirmed(true);
                  setCartLoading(false);
                  setInitialLoading(false);
                },
                (err) => {
                  EventService.emit("showError", {
                    message: `Error fetching providers: ${err?.message}`,
                  });
                  setCartLoading(false);
                  setInitialLoading(false);
                },
              );
            },
            (err) => {
              EventService.emit("showError", {
                message: `Error loading cart items: ${err?.message}`,
              });
              setCartLoading(false);
              setInitialLoading(false);
            },
          );
        } else {
          setInitialLoading(false);
        }
      };

      if (initialCartData?.addressId) {
        // if (true) {
        navigoDashboardUtils.getPatientAddress(
          selectedFamilyMember.memberPatientId,
          (res) => {
            const addresses = res || [];
            setAddressList(addresses);
            const match = addresses.find(
              (a) => a.id === initialCartData.addressId,
              // (a) => a.id === 14197,
            );
            if (match) {
              setAddressSelected(match);
            } else {
              EventService.emit("showError", {
                message: "Address from cart not found",
              });
            }
            finishAutoSelect();
          },
          (err) => {
            EventService.emit("showError", {
              message: `Error fetching addresses: ${err?.message}`,
            });
            finishAutoSelect();
          },
        );
      } else {
        finishAutoSelect();
      }
    }
  }, [selectedFamilyMember, serviceTypeSelected]);

  // Re-check serviceability when a "Raise a request" cart is opened for verification.
  //
  // Such a cart exists precisely BECAUSE the app's serviceability check rejected this address —
  // the patient uploaded a prescription anyway. Coverage may well have expanded since it was
  // raised, so the stored addressNotServiceable flag is history, not a current verdict. Ask
  // again on open rather than making the reviewer guess.
  //
  // Deliberately kept out of the hydration cascade above and strictly read-only: it never
  // touches addressSelected, never persists, never reconciles. Its whole effect is to set one
  // piece of local state, so no cart write and no backend cascade can originate here.
  useEffect(() => {
    if (openRecheckDoneRef.current) return;
    if (initialCartData?.addressNotServiceable !== true) return;
    if (initialCartData?.status !== CART_STATUS_PENDING_REVIEW) return;
    if (!addressSelected?.id || !groupServiceId) return;
    openRecheckDoneRef.current = true;
    // Same loader as the manual pick, so the reviewer can see why the address row is briefly
    // inert on open instead of watching an unexplained pause before a verdict appears.
    setAddressCheckLoading(true);
    checkAddressServiceability(addressSelected.id, groupServiceId).then(
      ({ serviceable, failed, stale }) => {
        // A manual pick landed on top of this one and now owns the loader; leave it alone.
        if (stale) return;
        setAddressCheckLoading(false);
        // No answer is not a verdict, so say nothing rather than accusing a possibly-fine
        // address. addressServiceable stays null and the field renders with no note.
        if (failed) return;
        setAddressServiceable(serviceable);
      },
    );
  }, [initialCartData, addressSelected, groupServiceId]);

  // Populate the (disabled) "Select group service" dropdown once service type +
  // booking-for are chosen, then auto-select. CREATE and EDIT-DRAFT always take
  // the 0th grouped service (the cart-bookable group, e.g. "Prescribed
  // diagnostics"); a cart past DRAFT takes the one matching its saved
  // groupServiceId so the dropdown reflects the cart. groupServiceId then
  // resolves from serviceSelected for every payload.
  //
  // When the fetch yields nothing usable the field is left EMPTY and the reason
  // is surfaced, rather than quietly substituting some other group: the group
  // service decides what the cart is and what may be added to it, so booking
  // against a stand-in is worse than not booking at all. The add-to-cart path
  // already refuses to proceed without a groupServiceId, so an empty field
  // blocks the flow on its own.
  useEffect(() => {
    if (
      planSelected &&
      serviceTypeSelected &&
      patientDetails &&
      selectedFamilyMember
    ) {
      getServices((groupedServices, failed) => {
        if (serviceSelected) return;
        // Honor the cart's group service only once the cart has moved past DRAFT
        // (VERIFY and later), where the saved groupServiceId is settled and must
        // be reflected. A DRAFT is treated like a fresh CREATE and takes the 0th
        // grouped service: a draft's groupServiceId is just whatever the first
        // add-to-cart happened to write, so validating against it would fail the
        // screen over a stale saved value instead of over what is actually active
        // now. On a DRAFT the only failure that matters is the fetch returning no
        // active group service at all.
        const cartGroupServiceId =
          cartStatus != null && cartStatus !== CART_STATUS_DRAFT
            ? initialCartData?.groupServiceId
            : null;
        const chosen = cartGroupServiceId
          ? groupedServices.find((s) => s.serviceId === cartGroupServiceId)
          : groupedServices[0];
        if (chosen) {
          setGroupServiceError(null);
          setServiceSelected(chosen);
          return;
        }
        // The list the backend returns is already restricted to what is active
        // for this plan, so "not in the list" IS "not active" — there is no
        // inactive-but-present case to tell apart.
        const message = failed
          ? "Could not load the group service for this plan. Please retry."
          : cartGroupServiceId
            ? `The group service on this cart (ID ${cartGroupServiceId}) is no longer active for this plan and service type.`
            : "No active group service found for this plan and service type.";
        setServiceSelected(null);
        setGroupServiceError(message);
        EventService.emit("showError", { message });
      });
    } else {
      // Upstream selections are incomplete, so the field is not ready rather
      // than broken — never leave a previous failure's note on screen.
      setGroupServiceError(null);
    }
  }, [
    planSelected?.planId,
    serviceTypeSelected?.serviceTypeId,
    patientDetails?.id,
    selectedFamilyMember?.memberPatientId,
  ]);

  const handlePidSearch = useCallback(
    debounce((e, pid) => {
      if (pid && pid.length > 0 && !isNaN(parseInt(pid, 10))) {
        navigoDashboardUtils.fetchPatientId(
          pid,
          (res) => {
            if (res && res.id !== undefined) {
              setPatientIdList([res]);
            } else {
              setPatientIdList([]);
            }
          },
          (err) => {
            setPatientIdList([]);
          },
        );
      }
    }, 300),
    [],
  );

  const getFamilyDetails = () => {
    navigoDashboardUtils.fetchPatientId(
      selectedFamilyMember?.memberPatientId,
      (res) => {
        if (res && res.id != 3) {
          if (isDOBEmpty(res) || isEmailEmpty(res)) {
            setPatientInfo(res);
            setUpdatePatientInfoDialog(true);
          } else {
            // getServices();
          }
        } else {
          EventService.emit("showError", {
            message: `Patient is inactive`,
          });
        }
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const getModes = () => {
    const onResponse = (res) => {
      setTotalModes(res == null || res.length === 0 ? [] : res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getModes(onResponse, onError);
  };

  // Fetch the plan's group services for the selected service type + booking-for.
  // The cart flow only ever books a *grouped* service (serviceCategory 1, e.g.
  // "Prescribed diagnostics"), so we use res.groupedServices — not the flat
  // res.services — and its serviceId becomes the groupServiceId every cart
  // payload needs. onLoaded receives the grouped list so callers can
  // auto-select (always the 0th for CREATE; the cart's match for non-CREATE),
  // plus a `failed` flag — an empty list means "this plan has no active group
  // service", which is a different thing to say than "the call did not answer".
  const getServices = (onLoaded) => {
    if (
      !planSelected ||
      !serviceTypeSelected ||
      !patientDetails ||
      !selectedFamilyMember
    ) {
      return;
    }
    setLoading(true);
    const body = {
      pageNum: 0,
      pageSize: 0,
      planId: planSelected.planId,
      serviceType: serviceTypeSelected.serviceTypeId,
      patientId: patientDetails.id,
      memberPatientId: selectedFamilyMember?.memberPatientId,
      includeSubtypeIds: [],
      excludeSubtypeIds: [],
    };
    navigoDashboardUtils.getServices(
      body,
      (res) => {
        const groupedServices = res?.groupedServices || [];
        setServiceList(groupedServices);
        setServiceListToShow(groupedServices);
        setLoading(false);
        if (onLoaded) onLoaded(groupedServices, false);
      },
      (err) => {
        EventService.emit("showError", { message: `Error: ${err?.message}` });
        setServiceList([]);
        setServiceListToShow([]);
        setLoading(false);
        if (onLoaded) onLoaded([], true);
      },
    );
  };

  const getAccountsForPid = (id) => {
    setLoading(true);

    const onResponse = (res) => {
      if (activePidRef.current !== id) return; // patient moved on; not our accounts
      if (
        res != null &&
        res.accountCodes != null &&
        res.accountCodes.length != 0
      ) {
        setAccountList(res.accountCodes);
      } else if (autoSelectRef.current) {
        // The account-match effect only runs on a non-empty list, so nothing downstream
        // would ever end the cascade.
        failPlanHydration("No accounts found for this patient");
      }
      setLoading(false);
    };
    const onError = (err) => {
      setLoading(false);
      if (autoSelectRef.current) {
        failPlanHydration(`Error: ${err?.message}`);
        return;
      }
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    navigoDashboardUtils.getAccountsForPid(id, onResponse, onError);
  };
  const getPlansForPid = (pid, accId) => {
    setLoading(true);

    const onResponse = (res) => {
      if (activePidRef.current !== pid) return; // patient moved on; not our plans
      const plans =
        res == null || res.length == 0
          ? []
          : res.filter((e) => e.accountCode === accId && e.status === 1);
      setPlanList(plans);
      setLoading(false);
      // The API lists active plans only (200 null when the patient has none), so a cart whose
      // plan expired after it was raised usually lands here with an empty list — which the
      // plan-match effect never sees, since it only runs on a non-empty one.
      if (plans.length === 0 && autoSelectRef.current) {
        failPlanHydration(
          `Plan "${initialCartData?.planId}" not found or inactive for this patient`,
          { pin: true },
        );
      }
    };
    const onError = (err) => {
      setLoading(false);
      // A 404 "No active plans found" is the other way an expired plan surfaces.
      if (autoSelectRef.current) {
        failPlanHydration(`Error: ${err?.message}`, { pin: true });
        return;
      }
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    navigoDashboardUtils.getPlansForPid(pid, accId, onResponse, onError);
  };

  const getFamilyMembers = (pid) => {
    const onResponse = (res) => {
      // Without this the list is rebuilt from the `patientDetails` captured when the request
      // was issued, so a late response inserts the PREVIOUS patient as the current patient's
      // own family member.
      if (activePidRef.current !== pid) return;
      let list = res.families;
      list = list.map((e) => {
        return { ...e, dateOfBirth: getAgeYearFromDob(e?.dateOfBirth) };
      });
      list.unshift({
        firstName: patientDetails.firstName,
        lastName: patientDetails.lastName,
        memberPatientId: patientDetails.id,
        gender: patientDetails.gender,
        dateOfBirth: getAgeYearsFromDobMillis(patientDetails?.dateOfBirth),
        relation: 0,
      });

      setFamilyMemberList(list);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      // The family-match step waits on this list; without it the cascade cannot finish.
      if (autoSelectRef.current) abortAutoSelect();
    };
    navigoDashboardUtils.getFamilyMembers(pid, onResponse, onError);
  };

  const getAllRelation = () => {
    const onResponse = (res) => {
      let relations = res;
      relations.unshift({ code: 0, value: "Self", gender: 0 });
      setRelationsList(relations);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getAllRelation(onResponse, onError);
  };

  // Addresses belong to whoever the booking is FOR, not to the account holder. The "Self"
  // entry the family list unshifts carries the primary patient's own id as memberPatientId,
  // so this one lookup covers self and family member alike.
  const getPatientAddress = () => {
    const pid = selectedFamilyMember?.memberPatientId;
    if (pid == null) return;
    // Drop the previous list before the request goes out. It is the result of an older
    // fetch, so leaving it up presents stale rows as if they were current and invites a
    // click on an address that may no longer exist. Empty + `loading` is what makes the
    // dropdown render "Loading addresses…" instead.
    setAddressList([]);
    setAddressLoading(true);
    const onResponse = (res) => {
      // Booking-for moved on while this was in flight; these are someone else's addresses.
      if (activeBookingForPidRef.current !== pid) return;
      setAddressList(res == null || res.length == 0 ? [] : res);
      setAddressLoading(false);
    };
    const onError = (err) => {
      if (activeBookingForPidRef.current === pid) setAddressLoading(false);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getPatientAddress(pid, onResponse, onError);
  };

  // Address edit flow (for addresses without valid coordinates)
  const {
    dialogState: addrEditDialogState,
    setDialogState: addrEditSetDialogState,
    openLocationDialog: addrEditOpenLocationDialog,
    closeDialog: addrEditCloseDialog,
  } = useLocationDialog();

  const {
    flowState: addrFlowState,
    setFlowState: setAddrFlowState,
    openAddressFlow,
    closeFlow: closeAddrFlow,
  } = useAddressFlow();

  const { confirm, ConfirmDialog } = useConfirmDialog();

  const getCoordinatesFromAddressId = (addressId) => {
    return new Promise((resolve, reject) => {
      const onResponse = (res) => {
        resolve(res);
      };
      const onError = (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
        reject(err);
      };
      navigoDashboardUtils.getCoordinatesFromAddressId(
        addressId,
        onResponse,
        onError,
      );
    });
  };

  // Ask the vendor manager whether this address is covered, the same question the app asks
  // before it lets a patient past the address step.
  //
  // `serviceId` must be the GROUP service id: the endpoint takes exactly one service and derives
  // cart mode from that service's category (the `isCartBookingFlow` we send is tagged `json:"-"`
  // on the backend and discarded). Passing a child test id would silently opt out of both the
  // cart-enabled vendor filter and the Zyla-provider fallback. There is no bulk variant, so this
  // is one call per address — never a loop over cart items.
  //
  // Resolves { serviceable, failed, stale }. `failed` means we never got an answer, which is a
  // reason to stop but not a coverage verdict — callers must not report it as one.
  const checkAddressServiceability = (addressId, serviceId) => {
    // Nothing to check against yet. Don't invent a "not serviceable" out of missing inputs —
    // the existing !groupServiceId guard on the add-to-cart path already stops the flow.
    if (!addressId || !serviceId) {
      return Promise.resolve({
        serviceable: true,
        failed: false,
        stale: false,
      });
    }
    const seq = ++addressCheckSeqRef.current;
    return new Promise((resolve) => {
      const onResponse = (res) => {
        if (seq !== addressCheckSeqRef.current) {
          resolve({ serviceable: false, failed: false, stale: true });
          return;
        }
        resolve({
          serviceable: res?.serviceable === true,
          failed: false,
          stale: false,
        });
      };
      const onError = () => {
        if (seq !== addressCheckSeqRef.current) {
          resolve({ serviceable: false, failed: true, stale: true });
          return;
        }
        resolve({ serviceable: false, failed: true, stale: false });
      };
      navigoDashboardUtils.checkAddressServiceable(
        {
          serviceId,
          addressId,
          // Sent for parity with the app only — the backend ignores it and infers cart mode
          // from the service category.
          isCartBookingFlow: true,
        },
        onResponse,
        onError,
      );
    });
  };

  // Coverage is computed from lat/long, so an address pinned at (0, 0) has never been placed
  // on the map and cannot be checked or booked against.
  const hasValidCoordinates = (addr) =>
    Boolean(
      addr?.coordinates &&
      addr.coordinates.latitude !== 0 &&
      addr.coordinates.longitude !== 0,
    );

  const handleAddressSelectWithValidation = async (v) => {
    // Re-picking the address that is already selected is a no-op, and the dropdown fires
    // onChange for it just the same. Bail before anything with a consequence: no "this will
    // clear your provider and slot" prompt for a change that isn't one, no serviceability
    // call, and no addressId write — so the backend cascade never runs and the provider and
    // slot the operator already has survive untouched.
    //
    // An address still missing coordinates is exempt: re-picking it is how the operator opens
    // the map to repair it, which is a real change even though the id has not moved.
    if (
      v?.id != null &&
      v.id === addressSelected?.id &&
      hasValidCoordinates(v)
    ) {
      return;
    }
    // Address is upstream of provider + slot (the added tests are kept). Warn before
    // discarding downstream work; on an empty cart this proceeds silently.
    if (!(await confirmUpstreamChange(false))) return;
    const hadDownstream = hasCartDownstream();
    // When there is a cart to cascade, clear provider + slot locally and persist the new
    // address so the backend cascade (address → provider, slot) runs and reconciles.
    //
    // The serviceability check runs FIRST, before setAddressSelected / clearProviderAndSlot /
    // persistCartToBackend. That ordering is the whole point: a rejected address writes nothing,
    // so no addressId PUT goes out, so the backend cascade never runs and the operator keeps the
    // provider and slot they already had.
    const applyAddress = async (addr) => {
      setAddressCheckLoading(true);
      const { serviceable, failed, stale } = await checkAddressServiceability(
        addr?.id,
        groupServiceId,
      );
      // A newer pick superseded this one before we heard back; it owns both the loader and the
      // outcome now. Clearing the loader here would hide the spinner that check is still under.
      if (stale) return;
      setAddressCheckLoading(false);
      if (!serviceable) {
        EventService.emit("showError", {
          message: failed
            ? "Could not verify serviceability for this address. Please try again."
            : "This address is not serviceable",
        });
        return;
      }
      // A live pass supersedes whatever the on-open re-check concluded: it clears the red note
      // and re-enables provider selection.
      setAddressServiceable(true);
      setAddressSelected(addr);
      if (hadDownstream) {
        clearProviderAndSlot();
        if (addr?.id != null) persistCartToBackend({ addressId: addr.id });
      }
    };

    if (!hasValidCoordinates(v)) {
      let initialLocationData = null;
      if (v?.id) {
        try {
          const res = await getCoordinatesFromAddressId(v.id);
          const lat = res?.latitude;
          const lng = res?.longitude;
          if (
            typeof lat === "number" &&
            typeof lng === "number" &&
            !(lat === 0 && lng === 0)
          ) {
            initialLocationData = {
              latLng: { lat, lng },
              address: null,
              selectedLabel: "",
            };
          }
        } catch (e) {
          // ignore — map will open without an initial pin
        }
      }

      const result = await openAddressFlow({
        ...v,
        coordinates: v.coordinates || null,
        initialLocationData,
      });

      if (result?.confirmed) {
        // Only now, with coordinates saved — vendor coverage is computed from lat/long, so
        // checking before the repair would ask about a point at (0, 0).
        await applyAddress(result.data);
      }
    } else {
      await applyAddress(v);
    }
  };

  const closePatientInfoDialog = () => {
    setNewDob(null);
    setNewEmail("");
    setPatientInfo(null);
    setUpdatePatientInfoDialog(false);
  };
  const isDOBEmpty = (patient) => {
    const dob = patient?.dateOfBirth;
    return (
      dob === undefined ||
      dob === null ||
      dob === "" ||
      isNaN(dob) ||
      Number(dob) === 0
    );
  };

  const isEmailEmpty = (patient) => {
    const email = patient?.email;
    return (
      email === undefined ||
      email === null ||
      typeof email !== "string" ||
      email.trim() === ""
    );
  };

  const isValidPhoneNo = (phone) => {
    const regex = /^[0-9]{10}$/;

    return regex.test(phone);
  };
  const isValidEmail = (email) => {
    if (
      typeof email !== "string" ||
      email.trim() === "" ||
      !email.includes("@")
    ) {
      return false;
    }

    const [localPart, domain] = email.trim().split("@");

    if (!localPart || !domain) return false;

    const isValidEmailDomain = (domain) =>
      /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(domain);

    return isValidEmailDomain(domain);
  };

  const updatePatientInfo = (patient) => {
    if (isDOBEmpty(patient) && newDob === null) {
      EventService.emit("showError", {
        message: `Please fill the Date of birth`,
      });
      return;
    }
    if (
      isEmailEmpty(patient) &&
      newEmail !== "" &&
      isValidEmail(newEmail) === false
    ) {
      EventService.emit("showError", {
        message: `Please enter a valid email address`,
      });
      return;
    }
    const body = {
      patientId: patient.id,
      firstName: patient.firstName,
      lastName: patient.lastName ? patient.lastName : null,
      gender: patient.gender,
      dateOfBirth: isDOBEmpty(patient)
        ? moment(newDob).format("YYYY-MM-DD")
        : moment(patient.dateOfBirth).format("YYYY-MM-DD"),
      phoneNo: String(patient.phoneno),
      email: newEmail !== "" ? newEmail : patient.email,
      profileImage: patient.profileImage,
      countryCode: patient.countryCode,
    };

    const onResponse = (res) => {
      if (selectedFamilyMember != null) {
        EventService.emit("showError", {
          message: `Information updated`,
        });
        // setSelectedFamilyMember(null);

        setLoadingProfileUpdate(false);
        closePatientInfoDialog();
        // getServices();
        // getPrice();
      } else {
        let newPatient = { ...patientInfo };
        if (newDob !== null) {
          newPatient = {
            ...newPatient,
            dateOfBirth: moment(newDob).format("YYYY-MM-DD"),
          };
        }
        if (newEmail !== "") {
          newPatient = { ...newPatient, email: newEmail };
        }
        // Routed through selectPatient, not setPatientDetails: this is the second way a
        // patient gets selected in CREATE (picked a PID whose profile was missing DOB/email,
        // filled it in here), and it must re-key the screen exactly like the picker does.
        selectPatient(newPatient);
        setPatientContactNumber(newPatient?.phoneno);
        EventService.emit("showError", {
          message: `Information updated`,
        });

        setLoadingProfileUpdate(false);
        closePatientInfoDialog();
      }
    };
    const onError = (err) => {
      setSelectedFamilyMember(null);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoadingProfileUpdate(false);
    };

    if (!isDOBEmpty(patient) && newEmail === "") {
      onResponse("");
    } else {
      setLoadingProfileUpdate(true);
      navigoDashboardUtils.updateProfileInfo(body, onResponse, onError);
    }
  };

  function getAgeFromDob(dobMillis) {
    const dob = moment(dobMillis);
    const now = moment();

    let years = now.diff(dob, "years");
    const adjustedDob = dob.clone().add(years, "years");
    let months = now.diff(adjustedDob, "months");

    // Adjust if the current date is before the birth day of the month
    if (months < 0) {
      years--;
      months += 12;
    }

    const yearStr = `${years} year${years === 1 ? "" : "s"}`;
    const monthStr =
      months > 0 ? ` ${months} month${months === 1 ? "" : "s"}` : "";

    return `${yearStr}${monthStr}`;
  }

  function getAgeYearsFromDobMillis(dobMillis) {
    if (!dobMillis) return "-";

    const dob = moment(dobMillis);
    if (!dob.isValid()) return "-";

    const now = moment();
    let years = now.diff(dob, "years");
    const adjustedDob = dob.clone().add(years, "years");
    let months = now.diff(adjustedDob, "months");

    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years}`;
  }

  function getAgeYearFromDob(dobStr) {
    if (!dobStr) return "-";

    const dob = moment(dobStr, "YYYY-MM-DD", true);
    if (!dob.isValid()) return "-";

    const now = moment();
    const years = now.diff(dob, "years");

    return `${years}`;
  }

  // ---- Document handlers ----
  // Uploads the file TWICE on a family booking — once for the member, once for the account
  // holder — because a document row is readable only under the patient it is filed against,
  // while the cart shows up in both people's booking history. Same shape the patient app and
  // the navigo booking flow use; see api-cart-service's PrimaryMemberDocumentIds.
  //
  // The two ids go to different cart fields on purpose: this panel renders
  // prescriptionDocumentIds alone, so the reviewer sees one tile per file rather than each
  // prescription twice.
  const handleUploadDocument = (file) => {
    const accountHolderId = patientDetails?.id;
    const memberId = selectedFamilyMember?.memberPatientId;
    const isFamilyBooking =
      memberId != null &&
      accountHolderId != null &&
      memberId !== accountHolderId;
    const ownerId = isFamilyBooking ? memberId : accountHolderId;

    const onUploadError = (err) => {
      EventService.emit("showError", {
        message: `Error uploading document: ${err?.message}`,
      });
      setCartLoading(false);
    };

    // Commits both halves at once. A family booking that only managed the first upload never
    // gets here: the lists must stay aligned, so a half-uploaded file enters neither.
    const commit = (doc, primaryId) => {
      const newDocIds = [...documentsList.map((d) => d.id), doc.id].filter(
        (id) => id != null,
      );
      const newPrimaryIds = [
        ...alignPrimaryDocumentIds(
          documentsList.map((d) => d.id),
          primaryMemberDocumentIds,
        ),
        primaryId ?? 0,
      ];
      setDocumentsList((prev) => [...prev, doc]);
      setPrimaryMemberDocumentIds(newPrimaryIds);
      setSelectedDocument(doc);
      setCartLoading(false);
      persistCartToBackend({
        prescriptionDocumentIds: newDocIds,
        primaryMemberDocumentIds: newPrimaryIds,
      });
    };

    setCartLoading(true);
    cartDashboardUtils.uploadDocument(
      file,
      ownerId,
      DOCUMENT_FOLDER_MEDICAL_RECORDS,
      (res) => {
        if (res?.id == null) {
          onUploadError({ message: "upload returned no document id" });
          return;
        }
        if (!isFamilyBooking) {
          commit(res, 0);
          return;
        }
        cartDashboardUtils.uploadDocument(
          file,
          accountHolderId,
          DOCUMENT_FOLDER_OTHER_MEDIA,
          (mirror) => {
            if (mirror?.id == null) {
              onUploadError({
                message: "could not file a copy under the account holder",
              });
              return;
            }
            commit(res, mirror.id);
          },
          onUploadError,
        );
      },
      onUploadError,
    );
  };

  const handleSelectDocument = (doc) => {
    setSelectedDocument(doc);
  };

  // Unlink a document from the cart (removes its id from prescriptionDocumentIds). The
  // document itself survives in the patient's health locker — document-service has no
  // delete route — so this is a cart-level detach, not a deletion.
  //
  // Persists via the admin PUT directly rather than through persistCartToBackend, because it
  // skips reconcileFromCart, which clears the whole cart subtree whenever the server returns
  // zero serviceIds — the normal state of a prescription-upload cart, i.e. exactly the kind of
  // cart documents live on.
  //
  // (The patient PUT is now equally capable of deleting the LAST document: cartCascade.go used
  // to gate on `len(req.PrescriptionDocumentIds) > 0`, which collapsed "omitted" and "[]" and
  // silently dropped the clear. It is a nil check now, matching serviceIds.)
  //
  // documents are a graph node with no dependents (plan → documents), so providing them still
  // cannot clear tests/provider/slot.
  const handleDeleteDocument = async (doc) => {
    if (doc?.id == null || cartLoading) return;

    const result = await confirm({
      title: "Delete document",
      message: `Remove Doc ID ${doc.id} from this cart? It will stay in the patient's records but will no longer be attached to the cart.`,
      width: "600px",
      buttons: {
        1: "close", // renders the top-right X (resolves "1" = cancel)
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Delete", color: "zyOrange" },
      },
    });
    if (result !== "3") return;

    const cartId = initialCartData?.id ?? props.data?.cartId ?? createdCartId;
    if (!cartId) {
      EventService.emit("showError", {
        message: "Cart id missing, cannot delete document",
      });
      return;
    }

    // By INDEX, not by id: the account-holder's copy of this same file sits at the matching
    // index of primaryMemberDocumentIds, and detaching one half would leave the other rendering
    // on the other person's booking card as a document ops believes they removed.
    const removedAt = documentsList.findIndex((d) => d.id === doc.id);
    const remaining = documentsList.filter((_, i) => i !== removedAt);
    const remainingPrimary = alignPrimaryDocumentIds(
      documentsList.map((d) => d.id),
      primaryMemberDocumentIds,
    ).filter((_, i) => i !== removedAt);
    setCartLoading(true);
    cartDashboardUtils.updateCartByAdmin(
      cartId,
      {
        prescriptionDocumentIds: remaining.map((d) => d.id),
        primaryMemberDocumentIds: remainingPrimary,
      },
      () => {
        // Only mutate local state once the server has confirmed — a failed PUT must leave the
        // document on screen rather than pretending it is gone.
        setDocumentsList(remaining);
        setPrimaryMemberDocumentIds(remainingPrimary);
        // Re-point the viewer off the deleted doc, else it keeps rendering a dead URL.
        setSelectedDocument((cur) =>
          cur?.id === doc.id ? (remaining[0] ?? null) : cur,
        );
        setCartLoading(false);
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error deleting document: ${err?.message || "Unknown error"}`,
        });
        setCartLoading(false);
      },
    );
  };

  // ---- Cart dependency-graph clearing (mirrors api-cart-service cartCascade.go) ----
  // The backend is the source of truth for the cascade, but Bridge holds a lot of
  // un-persisted local state (enriched cartItems, provider objects, slot data) and, on
  // CREATE, can't round-trip a bare plan/account change (the patient upsert requires a
  // groupServiceId, which those changes clear). So Bridge clears its own downstream state
  // on an upstream change, matching the graph, and reconcileFromCart aligns to the server
  // for the changes that DO round-trip (VERIFY, address, provider, items).

  // True when there is downstream work an upstream change would discard. `clearsDocuments`
  // reflects the graph: documents hang off `plan` AND `bookedFor`, so an account / plan /
  // booking-for change puts them at risk — a service-type change must not prompt about
  // prescriptions it will not touch.
  const hasCartDownstream = (clearsDocuments = false) =>
    cartItems.length > 0 ||
    !!selectedProvider ||
    !!selectedDate ||
    !!selectedSlot ||
    (clearsDocuments && documentsList.length > 0);

  // Detach the uploaded prescriptions locally. Mirrors the backend edge `plan → documents`
  // (cartCascade.go): a prescription is evidence for an order under a specific plan, so an
  // account/plan change invalidates it server-side.
  //
  // Keeping the panel in sync is not cosmetic. handleUploadDocument builds its payload as
  // [...documentsList ids, newId], so a stale list is re-sent on the next upload — and because
  // the cascade lets an explicitly re-provided field survive its parent's clear (forward-fill),
  // those stale ids would win and the documents the backend just cleared would come back.
  const clearDocuments = () => {
    setDocumentsList([]);
    // Both lists are their own node under `plan` in the backend graph, so a plan change clears
    // both. Leaving this one populated locally would re-send it on the next upload and
    // forward-fill would resurrect exactly the copies the backend had just cleared.
    setPrimaryMemberDocumentIds([]);
    setSelectedDocument(null);
  };

  // Clear provider + slot only (keeps items). Graph: address / bookedFor / items → provider → slot.
  const clearProviderAndSlot = () => {
    setCartConfirmed(false);
    setProviders([]);
    setSelectedProvider(null);
    setSlotData({ dates: [], slots: {} });
    setSelectedDate(null);
    setSelectedSlot(null);
  };

  // Clear the whole cart-detail subtree (items + provider + slot). Graph: account / plan /
  // groupService (serviceType) invalidate the basket.
  const clearCartDetails = () => {
    setCartItems([]);
    clearProviderAndSlot();
  };

  // Everything that belongs to the CURRENTLY SELECTED PATIENT and must not outlive them.
  // Clearing the Patient ID has to leave the screen exactly as a fresh CREATE mount would:
  // the operator picks a new PID and gets that patient's world, nothing of the previous one.
  //
  // This is a data-integrity boundary, not cosmetics. Left behind, `documentsList` gets sent
  // as prescriptionDocumentIds under the NEW patient (handleUploadDocument appends to it),
  // and `initialCartData` keeps supplying the OLD patient's cart id to handleDeleteDocument —
  // i.e. one patient's prescription lands on another patient's cart. The backend does not
  // validate document ownership, so this function is the only thing preventing that.
  //
  // Deliberately NOT reset: docToken (a Bridge-USER token, not patient-scoped), totalModes,
  // relationsList, initialLoading — none of them belong to the patient.
  //
  // Purely local: it must never write to the backend. The previous patient's DRAFT is left
  // untouched on the server, so re-typing their PID loads the very same cart back.
  const resetPatientDerivedState = () => {
    setDocumentsList([]);
    setPrimaryMemberDocumentIds([]);
    setSelectedDocument(null);

    setInitialCartData(null);
    setCreatedCartId(null);
    setCartEventHistory([]);

    setPlanWalletIncluded(false);
    setPlanAllowedFamilyRelations([]);
    setPriceRows([]);
    setPriceTotal(null);
    setCartPaymentPreview(null);

    setPatientContactNumber(null);
    setPatientInfo(null);
    setNewDob(null);
    setNewEmail("");

    setOpenSelectDateSlot(false);
    setUpdatePatientInfoDialog(false);
    setShowCartPaymentDialog(false);
    setShowCartPaymentLinkDialog(false);
    setShowMarkOnHoldDialog(false);
    setShowMarkOnHoldSuccessDialog(false);
    setShowRejectOrderDialog(false);
    setShowRejectOrderSuccessDialog(false);

    // Refs survive re-renders, so a setter-only sweep would silently miss these.
    // draftHydratedPidRef is the one that makes re-picking the SAME patient work: the
    // hydration effect short-circuits on `draftHydratedPidRef.current === pid`, so without
    // this the operator could clear a PID, re-type it, and get an empty screen forever.
    draftHydratedPidRef.current = null;
    frozenPricesRef.current = null;
    autoSelectRef.current = mode !== "CREATE"; // back to its initial value
  };

  // Reconcile local UI to the cart the backend returned after a persist: a field the
  // server-side cascade cleared must disappear here too (render what the API returns).
  //
  // provider/slot are only reconciled when THIS persist changed an upstream (cascading)
  // field. A non-cascading write (e.g. prescriptionDocumentIds, remarks) must NOT clobber
  // a locally-selected-but-unpersisted provider: on a DRAFT the provider is ephemeral
  // (serviceProviderId is 0 on the backend until slot-confirm, exactly like the app), so
  // reading it back as 0 does not mean it was cleared.
  const CASCADING_FIELD_KEYS = [
    "accountCode",
    "planId",
    "groupServiceId",
    "bookedFor",
    "addressId",
    "serviceIds",
  ];
  const reconcileFromCart = (cart, changedFields = {}) => {
    if (!cart) return;
    const changedUpstream = Object.keys(changedFields).some((k) =>
      CASCADING_FIELD_KEYS.includes(k),
    );
    // The empty-basket check is gated on the same condition as provider/slot below, and for
    // the same reason: only a persist that could plausibly have cleared the items may act on
    // reading none back. Ungated, a non-cascading write (prescriptionDocumentIds, remarks)
    // emptied the cart panel on any cart the server reports zero serviceIds for — which is the
    // NORMAL state of a prescription-upload cart, and is why handleDeleteDocument has to
    // bypass this function entirely.
    if (!changedUpstream) return;
    const serverServiceIds = cart.serviceIds || [];
    if (serverServiceIds.length === 0) {
      // Server has no items (an upstream change cleared them) → clear the whole subtree.
      // Tests vanishing from the panel is not something to do silently: say it happened,
      // unless this very request is what emptied them (removing the last item).
      if (cartItems.length > 0 && !("serviceIds" in changedFields)) {
        EventService.emit("showError", {
          message:
            "The tests in this cart were cleared because a detail above them changed. Please add them again.",
        });
      }
      clearCartDetails();
      return;
    }
    if (!cart.serviceProviderId) {
      clearProviderAndSlot();
    } else if (!cart.selectedSlotId) {
      setSlotData({ dates: [], slots: {} });
      setSelectedDate(null);
      setSelectedSlot(null);
    }
  };

  // Warn-then-proceed guard for a destructive upstream change. Resolves true to proceed.
  // Only prompts when there is downstream data to lose (the user's "empty cart → clear
  // freely" rule). `clearsItems` distinguishes account/plan/serviceType (wipe the basket)
  // from bookedFor/address (keep the basket, drop only provider + slot).
  // Returns Promise<boolean>: on an empty cart it resolves(true) with no dialog; otherwise
  // it opens the house-style confirm dialog (button "3" = Continue) and resolves on answer.
  const confirmUpstreamChange = async (
    clearsItems,
    clearsDocuments = false,
  ) => {
    if (!hasCartDownstream(clearsDocuments)) return true;
    const base = clearsItems
      ? "the added tests, service provider and time slot"
      : "the service provider and time slot";
    const what =
      clearsDocuments && documentsList.length > 0
        ? `${base}, and the uploaded prescription(s)`
        : base;
    const result = await confirm({
      title: "Confirm change",
      message: `Changing this will clear ${what}. Do you want to continue?`,
      width: "600px",
      buttons: {
        1: "close", // reserved: renders the top-right X (resolves "1" = cancel)
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Continue", color: "zyOrange" },
      },
    });
    return result === "3";
  };

  // ---- Persist cart changes to backend ----
  // Routes the PUT by mode: CREATE / EDIT-DRAFT use the patient upsert (creates
  // the DRAFT cart on the first add, updates it thereafter); VERIFY uses the
  // admin PUT by cartId, since the patient endpoint only ever targets a DRAFT
  // cart. VIEW-ONLY never syncs. `fields` is whatever changed (serviceIds on
  // add/remove; serviceProviderId + slot fields + serviceIds on slot confirm).
  // serviceIds are replaced wholesale, so the full array is sent each time.
  // Every persist reconciles from the returned cart so a server-side clear shows in the UI.
  // `onPersisted` (optional) runs INSTEAD of reconcileFromCart on success — used by the
  // delete-while-confirmed flow, which aligns provider/slot state itself and must NOT let
  // reconcile tear the confirmed view down when the server cleared the provider.
  // bookedFor in the shape the backend stores it: 0 = self (the account holder), else the
  // member's patient id. undefined while no member is picked, so the key is omitted and the
  // stored value is preserved rather than being recorded as an explicit "self".
  const currentBookedFor = () => {
    const memberId = selectedFamilyMember?.memberPatientId;
    if (memberId == null) return undefined;
    return memberId === patientDetails?.id ? 0 : memberId;
  };

  const persistCartToBackend = (fields, onPersisted) => {
    if (mode === "VIEW-ONLY") return;

    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error saving cart: ${err?.message || "Unknown error"}`,
      });
    };

    if (mode === "VERIFY") {
      const cartId = initialCartData?.id ?? props.data?.cartId;
      if (!cartId) {
        EventService.emit("showError", {
          message: "Cart id missing, cannot save changes",
        });
        return;
      }
      cartDashboardUtils.updateCartByAdmin(
        cartId,
        fields,
        // Pass the delta (fields), NOT the full body, so provider/slot are only reconciled
        // when an upstream field actually changed (see reconcileFromCart).
        (res) => {
          const cart = res?.cart ?? res;
          if (onPersisted) onPersisted(cart);
          else reconcileFromCart(cart, fields);
        },
        onError,
      );
      return;
    }

    // CREATE / EDIT-DRAFT → patient upsert (creates draft on first add)
    const patientId = patientDetails?.id;
    const planId = planSelected?.planId;
    if (!patientId || !planId) {
      EventService.emit("showError", {
        message: "Select patient and plan before adding tests",
      });
      return;
    }
    if (!groupServiceId) {
      EventService.emit("showError", {
        message: "Select a service before adding tests",
      });
      return;
    }
    // accountSelected is the account CODE itself, not an object: accountList is populated from
    // res.accountCodes (a string array) and matched with `acc === initialCartData.accountCode`.
    // Reading `.accountCode` off it was therefore always undefined, and the key was silently
    // dropped from the payload — so Bridge never once persisted accountCode, the most upstream
    // rung of the cart graph.
    const accountCode =
      typeof accountSelected === "string" ? accountSelected : undefined;
    cartDashboardUtils.modifyActiveCart(
      patientId,
      {
        planId,
        groupServiceId,
        ...(accountCode ? { accountCode } : {}),
        // bookedFor travels on EVERY write, like planId/groupServiceId, because it is now an
        // upstream node of the documents (bookedFor -> documents: a family booking files one
        // copy of each prescription under the member). Sent only at slot-confirm, as it used to
        // be, the very first write of it reads as a change and clears the prescriptions
        // uploaded before it — which silently dropped the documents off every Bridge family
        // cart. Re-sending an unchanged value is inert: the cascade compares by value.
        ...(currentBookedFor() !== undefined
          ? { bookedFor: currentBookedFor() }
          : {}),
        ...fields,
      },
      (res) => {
        const cart = res?.cart ?? res;
        const id = cart?.id;
        if (id != null) setCreatedCartId(id);
        if (onPersisted) {
          onPersisted(cart);
          return;
        }
        // Pass the delta (fields), NOT the full modifyActiveCart body — the body always
        // carries planId/groupServiceId, which would falsely look like an upstream change.
        reconcileFromCart(cart, fields);
      },
      onError,
    );
  };

  // ---- Cart item handlers ----
  const handleAddToCart = (test) => {
    // Prevent duplicates
    if (cartItems.find((item) => item.id === test.id)) {
      EventService.emit("showError", {
        // Name the test the way the dropdown / cart rows do (label, not code).
        message: `${test.serviceName || test.name} is already in the cart`,
      });
      return;
    }
    const newServiceIds = [...cartItems.map((i) => i.id), test.id];
    setCartItems((prev) => [...prev, { ...test, available: true }]);
    persistCartToBackend({ serviceIds: newServiceIds });
  };

  const handleRemoveFromCart = (testId) => {
    const newServiceIds = cartItems
      .filter((i) => i.id !== testId)
      .map((i) => i.id);
    setCartItems((prev) => prev.filter((item) => item.id !== testId));

    // Removing an item while the cart is confirmed must NOT revert to modify-cart mode.
    // A deletion only shrinks the required test set, so re-derive providers for the smaller
    // cart and keep the confirmed view (see reselectProviderAfterRemoval).
    if (cartConfirmed && newServiceIds.length > 0) {
      reselectProviderAfterRemoval(newServiceIds);
      return;
    }

    persistCartToBackend({ serviceIds: newServiceIds });
    // If the last item was removed while the cart was confirmed, drop back to
    // the add-items (un-confirmed) state — otherwise no action button shows and
    // the user is stuck with an empty confirmed cart.
    if (newServiceIds.length === 0 && cartConfirmed) {
      setCartConfirmed(false);
      setProviders([]);
      setSelectedProvider(null);
    }
  };

  // After an item is removed from a CONFIRMED cart, keep the confirmed (provider-selected)
  // view instead of dropping to modify-cart. Re-fetch providers for the reduced cart, then
  // re-select the SAME provider — a deletion can only shrink coverage requirements, so it
  // still applies. Persisting items + provider together lets the backend cascade forward-fill
  // (keep the re-provided provider, clear only the slot), so the default reconcileFromCart
  // keeps the confirmed view. If the provider is somehow no longer covered, stay confirmed
  // with the dropdown unselected so the reviewer manually re-picks. Fetch-first so cartLoading
  // is always reset and the deletion is always persisted (mirrors the auto-load cascade).
  const reselectProviderAfterRemoval = (newServiceIds) => {
    const previousProviderId = selectedProvider?.id;
    setCartLoading(true);
    // items → provider → slot: the item change invalidates any selected slot.
    setSlotData({ dates: [], slots: {} });
    setSelectedDate(null);
    setSelectedSlot(null);

    const body = {
      patientId: patientDetails?.id,
      planId: planSelected?.planId,
      groupServiceId,
      serviceIds: newServiceIds,
      addressId: addressSelected?.id,
      // Eligibility is judged against whoever the booking is for — same value getSlots sends.
      bookedFor: selectedFamilyMember?.memberPatientId,
    };
    cartDashboardUtils.fetchProviders(
      body,
      (res) => {
        const providerList = res.providers || [];
        setProviders(providerList);
        const match = providerList.find((p) => p.id === previousProviderId);
        if (match) {
          handleSelectProvider(match);
          // Single forward-fill PUT: items + provider together. The backend keeps the
          // re-provided provider and clears only the slot, so the returned cart has a
          // non-zero serviceProviderId and the default reconcile keeps cartConfirmed true.
          persistCartToBackend({
            serviceIds: newServiceIds,
            serviceProviderId: match.id,
            mode: match.assignedServiceMode || "",
          });
        } else {
          // Provider no longer covers the reduced cart → stay confirmed but unselected.
          // Clear stale availability/eligibility/price from the previous provider so nothing
          // looks bookable, then persist items only while BYPASSING reconcile (which would flip
          // cartConfirmed to false when the backend clears the provider).
          setSelectedProvider(null);
          setCartItems((prev) =>
            prev.map((item) => ({
              ...item,
              available: true,
              notEligible: false,
              notEligibleMsg: "",
              price: null,
            })),
          );
          persistCartToBackend({ serviceIds: newServiceIds }, () => {});
        }
        setCartLoading(false);
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error refreshing providers: ${err?.message}`,
        });
        // Fetch failed — still persist the deletion (default reconcile drops to modify
        // mode cleanly) so the removed item does not reappear on reload.
        persistCartToBackend({ serviceIds: newServiceIds });
        setCartLoading(false);
      },
    );
  };

  // ---- Confirm cart → fetch providers ----
  // Wallet plans require a prescription on file. Returns true (and tells the operator why)
  // when the cart may not proceed. Checked at BOTH gates — Confirm cart and Book appointment —
  // because the document list can change after the cart is confirmed (a document can be
  // deleted, or the plan's wallet status can resolve late), so guarding only the first gate
  // would let a wallet cart reach booking with no prescription attached.
  const blockedByWalletPrescription = (action) => {
    if (!planWalletIncluded || walletBlockedForMember) return false;
    if (documentsList.length > 0) return false;
    EventService.emit("showError", {
      message: `Uploading a prescription document is mandatory for a plan with wallet. Please upload at least one document before ${action}.`,
    });
    return true;
  };

  const handleConfirmCart = () => {
    if (cartItems.length === 0) {
      EventService.emit("showError", {
        message: "Please add at least one test to the cart",
      });
      return;
    }
    // Gate here (before providers are fetched, while the cart is still in modify mode) so the
    // operator uploads the document up-front — uploading in modify mode also avoids the
    // confirmed-view revert.
    if (blockedByWalletPrescription("confirming the cart")) return;
    // Backstop for the disabled "Confirm cart" button. Only a live check can set this to false,
    // so it never fires on a cart we did not actually re-check.
    if (addressServiceable === false) {
      EventService.emit("showError", {
        message:
          "This address is not serviceable. Assign a lab before selecting a service provider.",
      });
      return;
    }
    setCartLoading(true);
    const coords = addressSelected?.coordinates;
    const body = {
      patientId: patientDetails?.id,
      planId: planSelected?.planId,
      groupServiceId,
      serviceIds: cartItems.map((item) => item.id),
      addressId: addressSelected?.id,
      // Eligibility is judged against whoever the booking is for — same value getSlots sends.
      bookedFor: selectedFamilyMember?.memberPatientId,
      // geolocationFilter:
      //   coords && coords.latitude && coords.longitude
      //     ? {
      //         latitude: coords.latitude,
      //         longitude: coords.longitude,
      //         radius: 5000,
      //       }
      //     : undefined,
    };
    cartDashboardUtils.fetchProviders(
      body,
      (res) => {
        const providerList = res.providers || [];
        setProviders(providerList);
        if (providerList.length > 0) {
          handleSelectProvider(providerList[0]);
        }
        setCartConfirmed(true);
        setCartLoading(false);
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error fetching providers: ${err?.message}`,
        });
        setCartLoading(false);
      },
    );
  };

  // ---- Provider selection — marks unavailable/not-eligible tests and enriches cart with pricing ----
  const handleSelectProvider = (provider) => {
    setSelectedProvider(provider);
    // Coverage returns one serviceModeDetails entry per provided service, carrying both its
    // price and its patient-eligibility verdict, so index once and read both off the same entry.
    const detailMap = {};
    (provider.serviceModeDetails || []).forEach((detail) => {
      detailMap[detail.serviceId] = detail;
    });
    // A booked cart is still run through here to resolve its persisted provider, but its prices
    // were frozen at booking time — coverage prices can have drifted since, so they must not
    // overwrite what the patient actually paid.
    const frozen = frozenPricesRef.current;
    setCartItems((prev) =>
      prev.map((item) => {
        const detail = detailMap[item.id];
        return {
          ...item,
          available: provider.supportedTests.includes(item.id),
          // "Not eligible" is the provider offering the test while THIS patient does not
          // qualify for it (age/gender rules) — a different thing from "not available", where
          // the provider does not offer it at all. Eligibility is per provider+service, so it
          // is recomputed on every provider change. Both states block booking, but only this
          // one carries a per-service reason the operator has to be shown.
          notEligible: detail?.isNotEligible === true,
          notEligibleMsg: detail?.notEligibleMsg || "",
          price: frozen
            ? (frozen.get(item.id) ?? null)
            : (detail?.discountedPrice ?? null),
        };
      }),
    );
  };

  // User-initiated provider change from the DocCartView dropdown. Updates local
  // state and persists the new provider to the cart. (Internal cascade/confirm
  // calls use handleSelectProvider directly so they don't trigger a PUT.)
  const handleProviderChange = (provider) => {
    handleSelectProvider(provider);
    // Provider change invalidates the slot (graph: provider → slot). Clear locally now;
    // the persist round-trip + reconcileFromCart keep it aligned with the server.
    setSlotData({ dates: [], slots: {} });
    setSelectedDate(null);
    setSelectedSlot(null);
    if (provider?.id != null) {
      persistCartToBackend({
        serviceProviderId: provider.id,
        mode: provider?.assignedServiceMode || "",
      });
    }
  };

  // ---- Modify cart → go back to editing ----
  const handleModifyCart = () => {
    setCartConfirmed(false);
    setProviders([]);
    setSelectedProvider(null);
    // Reset availability/eligibility flags — both are verdicts of the provider we just dropped.
    setCartItems((prev) =>
      prev.map((item) => ({
        ...item,
        available: true,
        notEligible: false,
        notEligibleMsg: "",
      })),
    );
  };

  // ---- Book appointment → fetch slots ----
  const handleBookAppointment = () => {
    const allAvailable = cartItems.every((item) => item.available);
    if (!allAvailable) {
      EventService.emit("showError", {
        message:
          "Some tests are not available. Remove them or change service provider.",
      });
      return;
    }
    // Backstop for the disabled "Book appointment" button. The app blocks the same way
    // (cartCheckoutScreen "Continue"), and booking past it would create an appointment for a
    // test the patient does not qualify for.
    if (cartItems.some((item) => item.notEligible)) {
      EventService.emit("showError", {
        message:
          "Some tests are not eligible for this patient. Remove them or change service provider.",
      });
      return;
    }
    if (blockedByWalletPrescription("booking the appointment")) return;
    setCartLoading(true);
    const coords = addressSelected?.coordinates;
    const body = {
      serviceProviderID: selectedProvider?.id,
      planId: planSelected?.planId,
      patientId: patientDetails?.id,
      bookedFor: selectedFamilyMember?.memberPatientId,
      serviceId: groupServiceId,
      childServiceIds: cartItems.map((item) => item.id),
      addressId: addressSelected?.id,
      // geolocationFilter:
      //   coords && coords.latitude && coords.longitude
      //     ? {
      //         latitude: coords.latitude,
      //         longitude: coords.longitude,
      //         radius: 5000,
      //       }
      //     : undefined,
    };
    cartDashboardUtils.getSlots(
      body,
      (res) => {
        setSlotData({
          dates: res.dates || [],
          slots: res.slots || {},
        });
        setSelectedDate(null);
        setSelectedSlot(null);
        setOpenSelectDateSlot(true);
        setCartLoading(false);
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error fetching slots: ${err?.message}`,
        });
        setCartLoading(false);
      },
    );
  };

  // The "Payment details" dialog (already-paid vs applicable breakdown) is only
  // meaningful when the cart already has prior payments. With no paymentOrderIds
  // (null / [] / ""), "Already paid" is always 0, so that screen adds nothing —
  // skip it and open the "Proceed to pay" (CartPaymentLinkDialog) step directly.
  const cartHasPriorPayments = (paymentOrderIds) =>
    Array.isArray(paymentOrderIds)
      ? paymentOrderIds.length > 0
      : paymentOrderIds != null && paymentOrderIds !== "";

  const openCartPaymentStep = (paymentOrderIds) => {
    if (cartHasPriorPayments(paymentOrderIds)) {
      setShowCartPaymentDialog(true);
    } else {
      setShowCartPaymentLinkDialog(true);
    }
  };

  // ---- Slot selection confirm → build appointment payload & open payment flow ----
  // CREATE / EDIT-DRAFT slot-confirm.
  //
  // Persists slot/provider on the DRAFT cart (patient PUT), then previews the
  // payment delta and opens the cart payment-details dialog. From there
  // CartPaymentLinkDialog drives the same approve flow as VERIFY (method select
  // → share link → POST /admin/{cartId}/approve) instead of the legacy
  // create-appointment (v1/appointment) flow.
  const persistDraftSlotAndPreview = (slotFields) => {
    const patientId = patientDetails?.id;
    const planId = planSelected?.planId;
    if (!slotFields || !patientId || !planId) {
      EventService.emit("showError", {
        message: "Select patient and plan before continuing",
      });
      return;
    }
    setCartPaymentLoading(true);
    // The cart stays a DRAFT here — deliberately. This PUT used to also send
    // status=PENDING_REVIEW, because the admin approve endpoint only accepted
    // status 2; approve now takes a DRAFT directly (a bridge cart is an
    // employee-only admin action either way). Flipping early put the cart in the
    // ops review queue before anyone had committed to it, and the backend now
    // rejects a client-set PENDING_REVIEW with a 400 outright.
    const slotPutBody = {
      planId,
      groupServiceId,
      ...slotFields,
    };
    cartDashboardUtils.modifyActiveCart(
      patientId,
      slotPutBody,
      (res) => {
        const cartId =
          res?.id ?? res?.cart?.id ?? createdCartId ?? initialCartData?.id;
        if (!cartId) {
          EventService.emit("showError", {
            message: "Cart id missing, cannot continue",
          });
          setCartPaymentLoading(false);
          return;
        }
        setCreatedCartId(cartId);
        cartDashboardUtils.getCartPaymentSublimit(
          cartId,
          true,
          (preview) => {
            setCartPaymentPreview(preview);
            openCartPaymentStep(
              res?.paymentOrderIds ?? res?.cart?.paymentOrderIds,
            );
            setCartPaymentLoading(false);
          },
          (err) => {
            EventService.emit("showError", {
              message: `Error fetching payment details: ${err?.message || "Unknown error"}`,
            });
            setCartPaymentLoading(false);
          },
        );
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error saving slot: ${err?.message || "Unknown error"}`,
        });
        setCartPaymentLoading(false);
      },
    );
  };

  const handleSlotConfirm = (date, slot) => {
    setSelectedDate(date);
    setSelectedSlot(slot);
    setOpenSelectDateSlot(false);

    // Provider, slot and services to persist onto the cart, mirroring the app's
    // add/edit PUT contract (provider, time slot, services).
    // `mode` belongs to the provider, so it is only ever sent WITH one. It used to default to
    // "" — a present-but-empty value, which the backend reads as an explicit change to blank
    // rather than as "not provided". Combined with serviceProviderId being undefined (and so
    // dropped by JSON.stringify) that persisted a blank mode next to the PREVIOUS provider's
    // id, and approve then ran against a provider the operator never chose. Omitting the key
    // is how you say "unchanged"; the backend clears mode itself when the provider changes.
    const slotFields = {
      serviceProviderId: selectedProvider?.id,
      ...(selectedProvider?.assignedServiceMode
        ? { mode: selectedProvider.assignedServiceMode }
        : {}),
      selectedSlotDate: date?.dayDate
        ? date.dayDate + "T00:00:00.000Z"
        : undefined,
      selectedSlotTime: slot?.value ?? 0,
      selectedSlotId: slot?.key ?? 0,
      serviceIds: cartItems.map((item) => item.id),
      bookedFor: currentBookedFor() ?? 0,
      addressId: addressSelected?.id,
    };

    // VERIFY: persist slot/provider via the admin PUT (PENDING_REVIEW carts the
    // patient PUT cannot touch), then preview the payment delta and open the
    // cart payment-details dialog. CREATE / EDIT-DRAFT do the same below, but
    // persist via the patient PUT since their cart is still a DRAFT.
    if (mode === "VERIFY") {
      const cartId = initialCartData?.id ?? props.data?.cartId;
      if (!cartId) {
        EventService.emit("showError", {
          message: "Cart id missing, cannot continue",
        });
        return;
      }
      setCartPaymentLoading(true);
      cartDashboardUtils.updateCartByAdmin(
        cartId,
        slotFields,
        () => {
          cartDashboardUtils.getCartPaymentSublimit(
            cartId,
            true,
            (res) => {
              setCartPaymentPreview(res);
              openCartPaymentStep(initialCartData?.paymentOrderIds);
              setCartPaymentLoading(false);
            },
            (err) => {
              EventService.emit("showError", {
                message: `Error fetching payment details: ${err?.message || "Unknown error"}`,
              });
              setCartPaymentLoading(false);
            },
          );
        },
        (err) => {
          EventService.emit("showError", {
            message: `Error saving slot: ${err?.message || "Unknown error"}`,
          });
          setCartPaymentLoading(false);
        },
      );
      return;
    }

    // CREATE / EDIT-DRAFT → same as VERIFY above, but the cart is still a DRAFT
    // so it persists via the patient PUT.
    persistDraftSlotAndPreview(slotFields);
  };

  // Continue from the cart payment-details preview (VERIFY) → hand off to the
  // CartPaymentLinkDialog flow (method select → share link → approve), which
  // POSTs /api/v1/cart/admin/{cartId}/approve and handles the refund /
  // wallet-debit / payment-link outcome.
  const handleCartPaymentContinue = () => {
    setShowCartPaymentDialog(false);
    setShowCartPaymentLinkDialog(true);
  };

  // ---- Resume (header CTA on an ON_HOLD cart) ----
  // ON_HOLD→PENDING_REVIEW via POST /resume. Direct call with no confirmation
  // dialog, matching the dashboard's row-level Resume: the action is trivially
  // undoable (mark on hold again) and the reviewer is here to act on the cart.
  //
  // On success the local status flips to PENDING_REVIEW, which un-freezes the
  // screen (isCartReadOnly) and swaps this CTA for Mark-as-on-hold / Reject —
  // so the reviewer can carry straight on without re-opening the cart.
  //
  // The dashboard behind us stays mounted (index.js hides it rather than
  // unmounting), so its row for this cart would otherwise still read "On hold";
  // resetDashboardReload re-runs its fetch while it is hidden.
  const handleResumeOrder = () => {
    if (resuming || initialCartData?.id == null) return;
    setResuming(true);
    cartDashboardUtils.resumeCart(
      initialCartData.id,
      (res) => {
        setResuming(false);
        // /resume echoes the updated cart, but fall back to setting the status
        // by hand on a bare ack: an empty-object response is truthy, so
        // spreading it blindly would leave the screen stuck showing "On hold"
        // after a resume the backend actually performed.
        setInitialCartData((prev) =>
          res?.status != null
            ? { ...(prev || {}), ...res }
            : { ...prev, status: CART_STATUS_PENDING_REVIEW },
        );
        if (typeof props.resetDashboardReload === "function") {
          props.resetDashboardReload();
        }
      },
      (err) => {
        setResuming(false);
        EventService.emit("showError", {
          message: `Failed to resume order: ${err?.message || "Unknown error"}`,
        });
      },
    );
  };

  // ---- Reorder (VIEW-ONLY header CTA / the Reject-order success dialog) ----
  // Copy this (terminal) cart's booking identity + selection off initialCartData — the
  // patient_carts doc loaded for this cart — and PUT /cart/patient/{patientId} to land it
  // on the patient's DRAFT, then open that draft in EDIT-DRAFT.
  //
  // The body carries no `id`, and that does NOT mean "create a fresh cart". With no id the
  // backend targets `{patientId, status: DRAFT}` (UpsertPatientCart), and a patient can hold
  // exactly ONE draft (unique_patient_draft_cart, a unique index partial on status=1) — the
  // very same draft the app writes to. So a reorder either mints a draft (the patient has
  // none) or REPLACES their live in-app basket. That second case is destructive and
  // invisible, which is what the pre-check below exists to surface.
  //
  // On success we navigate to a new EDIT-DRAFT screen for the resulting cart id; index.js
  // re-keys the screen so it remounts and runs its load cascade, presenting the copied cart
  // as a newly created, fully-editable one.
  const handleReorder = async () => {
    const src = initialCartData;
    if (!src?.patientId || !src?.planId || !src?.groupServiceId) {
      EventService.emit("showError", {
        message: "Cart details missing, cannot reorder",
      });
      return;
    }

    // Captured from THIS render, before anything closes it: the reject-order success dialog
    // is dismissed by its own onReorder (two stacked DialogContainers is not a shape this
    // screen renders), so backing out has to put the operator back on it rather than on a
    // dead read-only screen.
    const cameFromRejectDialog = showRejectOrderSuccessDialog;
    const abortReorder = () => {
      setCartPaymentLoading(false);
      if (cameFromRejectDialog) setShowRejectOrderSuccessDialog(true);
    };

    // Covers the pre-check round trip — the CTA is disabled on it, so a slow GET can't be
    // double-clicked into two reorders. It stays up through the write on the quiet path, and
    // is dropped only to show the confirm below.
    setCartPaymentLoading(true);

    // Does this patient already have a DRAFT that this reorder would overwrite? The
    // no-query-param GET returns their draft regardless of (plan, groupService) context,
    // which is what we want: ANY draft is at risk, not just one in this cart's context.
    let existingDraft = null;
    let draftCheckFailed = false;
    try {
      const res = await new Promise((resolve, reject) => {
        cartDashboardUtils.fetchActiveCartByPatientId(
          src.patientId,
          resolve,
          reject,
        );
      });
      // An empty response ({}) / absent cart.id means the patient has no draft. The source
      // cart is always terminal so it can never itself BE the draft; the id compare is
      // belt-and-braces.
      const draft = res?.cart ?? res;
      if (draft?.id && draft.id !== src.id) existingDraft = draft;
    } catch (err) {
      console.warn("Reorder: draft pre-check failed", err?.message);
      draftCheckFailed = true;
    }
    // A failed pre-check must never authorise a silent overwrite, so it warns too — just
    // without being able to say what is at stake.
    if (existingDraft || draftCheckFailed) {
      // The spinner MUST come down before the dialog opens. SimpleBackdrop is a full-screen
      // MUI Backdrop, so leaving it up puts it OVER the dialog, swallowing the Cancel /
      // Continue clicks and hanging the whole flow on a spinner that never stops.
      setCartPaymentLoading(false);
      const count = existingDraft?.serviceIds?.length ?? 0;
      const message = existingDraft
        ? `This patient already has a draft cart (Cart ID ${existingDraft.id}, ${count} ${
            count === 1 ? "test" : "tests"
          } added). Reordering will replace that draft's tests, address, service provider and time slot with this order's details. This cannot be undone.`
        : "Could not check whether this patient has an existing draft cart. Continuing may replace it. This cannot be undone.";
      const result = await confirm({
        title: "Confirm reorder",
        message,
        width: "600px",
        buttons: {
          1: "close", // reserved: renders the top-right X (resolves "1" = cancel)
          2: { label: "Cancel", color: "zyGreen" },
          3: { label: "Continue", color: "zyOrange" },
        },
      });
      if (result !== "3") {
        abortReorder();
        return;
      }
    }

    // A slot is only worth carrying over while it is still bookable. A booked or
    // long-rejected cart holds a date in the PAST, and /approve's DRAFT gate only checks
    // that a slot is non-zero — a stale one sails straight through it. Slot dates are stored
    // date-only in UTC ("<dayDate>T00:00:00.000Z"), so compare on the date part; "0001-01-01"
    // is Go's zero time (the same sentinel SelectDateSlotSection's requestedSlot uses).
    // Dropping it costs nothing: the picker auto-selects the first available slot in
    // EDIT-DRAFT.
    const srcSlotDay = src.selectedSlotDate
      ? moment.utc(src.selectedSlotDate).format("YYYY-MM-DD")
      : null;
    const keepSlot =
      !!srcSlotDay &&
      srcSlotDay !== "0001-01-01" &&
      srcSlotDay >= moment().format("YYYY-MM-DD");

    // Every field the upsert accepts, except `id` (see above) and `patientId`
    // (modifyActiveCart injects it). Deliberately NOT copied: appointmentId,
    // paymentOrderIds, eventReferences, rejectReason*, holdReason*, pendingVerificationAt,
    // creationMode, addressNotServiceable — money, provenance and lifecycle fields that
    // belong to the ORIGINAL order, and none of them is settable here anyway.
    const body = {
      bookedFor: src.bookedFor,
      addressId: src.addressId,
      planId: src.planId,
      groupServiceId: src.groupServiceId,
      // `?? []` is load-bearing. A cart with no items/documents serialises them as null, and
      // the backend reads null as "not provided → preserve"; landing on an existing draft
      // that would silently inherit ITS tests and prescriptions. An explicit [] clears them,
      // which is what a faithful copy of an empty list means.
      serviceIds: src.serviceIds ?? [],
      prescriptionDocumentIds: src.prescriptionDocumentIds ?? [],
      // No equivalent fix exists for these two: the backend reads serviceProviderId 0 and
      // mode "" as "not provided" by design, so a source cart that never got a provider
      // cannot null out one sitting on the draft. The cascade covers it in practice —
      // provider hangs off items/address/bookedFor and mode hangs off provider, so any
      // difference in those clears both, and a draft matching on all three is effectively
      // the same cart already.
      serviceProviderId: src.serviceProviderId,
      mode: src.mode,
      ...(keepSlot
        ? {
            selectedSlotDate: src.selectedSlotDate,
            selectedSlotTime: src.selectedSlotTime,
            selectedSlotId: src.selectedSlotId,
          }
        : {
            selectedSlotDate: "0001-01-01T00:00:00.000Z",
            selectedSlotTime: 0,
            selectedSlotId: 0,
          }),
      // Request key is geolocationFilter; the stored field is geolocationDetails.
      geolocationFilter: src.geolocationDetails,
      // Both are ignored by the backend when empty ("" reads as not-provided), so only send
      // them when there is something to send. accountCode is always populated on
      // initialCartData — resolveAccountCode derives it from planId when the cart doc omits
      // it — so without this a reordered cart stored "" where every other Bridge cart stores
      // the real account.
      ...(src.accountCode ? { accountCode: src.accountCode } : {}),
      ...(src.remarks ? { remarks: src.remarks } : {}),
      status: CART_STATUS_DRAFT,
    };
    // Already true on the no-dialog path (a same-value set bails out); this re-raises it
    // after a confirm.
    setCartPaymentLoading(true);
    cartDashboardUtils.modifyActiveCart(
      src.patientId,
      body,
      (res) => {
        const newCartId = res?.id ?? res?.cart?.id;
        if (newCartId == null) {
          abortReorder();
          EventService.emit("showError", {
            message: "Reorder failed: no cart id returned",
          });
          return;
        }
        setCartPaymentLoading(false);
        props.setView(1, { cartId: newCartId, mode: "EDIT-DRAFT" });
      },
      (err) => {
        abortReorder();
        EventService.emit("showError", {
          message: `Reorder failed: ${err?.message || "Unknown error"}`,
        });
      },
    );
  };

  // Check if DocCartView should be enabled. The cart only becomes interactive
  // once the LAST user-details field (Select address) is filled. Until then the
  // real Doc/Cart layout still renders (see DocCartView) but greyed + locked, so
  // the reviewer can see the structure before completing user details.
  //
  // A live "not serviceable" verdict locks it the same way: with no vendor covering the
  // address, nothing downstream of it can be decided, so the whole Doc/Cart panel greys out
  // until a lab is assigned. Only an actual check can set this — the cart's historical
  // addressNotServiceable flag must not lock the reviewer out of the very carts they are
  // here to unblock.
  //
  // It stays locked while a check is still in flight too. The verdict may well be "no", and
  // letting the operator start adding tests in that window only to grey the panel out from
  // under them mid-search is worse than making them wait for the answer.
  const isDocCartEnabled =
    addressSelected != null &&
    addressServiceable !== false &&
    !addressCheckLoading;

  const resetValues = (code) => {
    // Upstream change → invalidate cart details per the dependency graph (mirrors
    // cartCascade.go): patient/account/plan/serviceType/service/mode wipe the basket;
    // bookedFor (9) keeps the tests and drops the provider, slot and prescriptions.
    if (code === 9) {
      clearProviderAndSlot();
      // bookedFor -> documents: the member's copy of each prescription is filed under the
      // member being replaced, so the backend clears both lists. Mirror it locally or the
      // stale ids get re-sent on the next upload and forward-fill resurrects them.
      clearDocuments();
    } else {
      clearCartDetails();
    }
    switch (code) {
      case 1: // after patient id change
        // The patient is the most upstream rung of all: everything on this screen belongs to
        // them. Wipe the patient-scoped world before clearing the identity chain below, so the
        // next PID starts from a screen indistinguishable from a fresh mount. Lives here rather
        // than in the Autocomplete's onChange because handleUpdatePatientInfo also sets the
        // patient directly, bypassing that handler.
        resetPatientDerivedState();
        setPatientIdList([]);
        // selectPatient(null) so the host drops its patient and re-keys: clearing the PID
        // remounts this screen, which is the real reset. The setters below remain as defence
        // in depth (and carry the non-CREATE modes, which never re-key).
        selectPatient(null);
        setAccountList([]);
        setAccountSelected(null);
        setPlanList([]);
        setPlanSelected(null);
        setPlanError(null);
        setServiceTypeList([]);
        setServiceTypeSelected(null);
        setServiceList([]);
        setServiceListToShow([]);
        setServiceSelected(null);
        setServiceModeList([]);
        setServiceModeSelected(null);

        setFamilyMemberList([]);
        setSelectedFamilyMember(null);

        setAddressList([]);
        setAddressSelected(null);

        setLoading(false);
        break;
      case 2: // after account change
        // account → plan → documents: the backend clears prescriptions on this change.
        clearDocuments();
        setPlanList([]);
        setPlanSelected(null);
        setPlanError(null);
        setServiceTypeList([]);
        setServiceTypeSelected(null);
        setServiceList([]);
        setServiceListToShow([]);
        setServiceSelected(null);
        setServiceModeList([]);
        setServiceModeSelected(null);

        setSelectedFamilyMember(null);

        setAddressList([]);
        setAddressSelected(null);

        setLoading(false);
        break;

      case 3: // after plan selection change
        // plan → documents: the backend clears prescriptions on this change.
        clearDocuments();
        setServiceTypeList([]);
        setServiceTypeSelected(null);
        setServiceList([]);
        setServiceListToShow([]);
        setServiceSelected(null);
        setServiceModeList([]);
        setServiceModeSelected(null);

        setSelectedFamilyMember(null);

        setAddressList([]);
        setAddressSelected(null);

        setLoading(false);
        break;

      case 4: // after service type change
        setServiceListToShow([]);
        setServiceSelected(null);
        setServiceModeList([]);
        setServiceModeSelected(null);

        setSelectedFamilyMember(null);

        setAddressList([]);
        setAddressSelected(null);

        setLoading(false);
        break;

      case 5: // after service code change
        setServiceModeList([]);
        setServiceModeSelected(null);

        setSelectedFamilyMember(null);

        setAddressList([]);
        setAddressSelected(null);

        setLoading(false);
        break;

      case 6: // after mode change
        setServiceModeSelected(null);

        setSelectedFamilyMember(null);

        setAddressList([]);
        setAddressSelected(null);

        setLoading(false);
        break;

      case 9: // after booking-for (family member) change
        setServiceListToShow([]);
        setServiceSelected(null);
        setServiceModeList([]);
        setServiceModeSelected(null);

        setAddressList([]);
        setAddressSelected(null);

        setLoading(false);
        break;

      // default:
      //   setPatientIdList([]);
      //   setPatientDetails(null);
      //   setAccountList([]);
      //   setAccountSelected(null);
      //   setPlanList([]);
      //   setPlanSelected(null);
      //   setServiceTypeList([]);
      //   setServiceTypeSelected(null);
      //   setServiceList([]);
      //   setServiceListToShow([]);
      //   setServiceSelected(null);
      //   setServiceModeList([]);
      //   setServiceModeSelected(null);

      //   setFamilyMemberList([]);
      //   setSelectedFamilyMember(null);

      //   setAddressList([]);
      //   setAddressSelected(null);

      //   setLoading(false);
      //   break;
    }
  };
  return (
    <>
      {(initialLoading || cartPaymentLoading) && <SimpleBackdrop />}
      <div className="cart-module-page-padding">
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className="cart-module-view">
              <div className="cart-module-heading-with-back-button">
                <div
                  className="cart-module-back-btn"
                  onClick={() => {
                    exitScreen();
                  }}
                >
                  <FontIcon
                    id="back_button"
                    style={{ fontSize: "36px", marginTop: "2px" }}
                  >
                    arrow_back
                  </FontIcon>
                </div>
                <h1>{`Prescribed lab tests and scans`}</h1>
              </div>
              <div className="cart-module-buttons-container">
                <div className="cart-module-buttons-right-alignment">
                  {canReorder && (
                    <Button
                      id="reorder_cta"
                      className={"zy-btn-orange-1"}
                      disabled={loading || initialLoading || cartPaymentLoading}
                      style={{ marginRight: "10px" }}
                      onClick={() => handleReorder()}
                    >
                      {"Reorder"}
                    </Button>
                  )}
                  {initialCartData?.status === CART_STATUS_PENDING_REVIEW && (
                    <>
                      <Button
                        id="mark_on_hold_cta"
                        className={"zy-btn-orange-1"}
                        disabled={loading || initialLoading}
                        style={{ marginRight: "10px" }}
                        onClick={() => setShowMarkOnHoldDialog(true)}
                      >
                        {"Mark as on hold"}
                      </Button>
                      <Button
                        id="reject_order_cta"
                        className={"zy-btn-blue-1"}
                        disabled={loading || initialLoading}
                        style={{ marginRight: "10px" }}
                        onClick={() => setShowRejectOrderDialog(true)}
                      >
                        {"Reject order"}
                      </Button>
                    </>
                  )}
                  {/* An on-hold cart's only forward move is back into review.
                      Not offered in VIEW-ONLY: that mode is read-only by mode
                      regardless of status. */}
                  {!isViewOnly && cartStatus === CART_STATUS_ON_HOLD && (
                    <Button
                      id="resume_order_cta"
                      className={"zy-btn-orange-1"}
                      disabled={loading || initialLoading || resuming}
                      style={{ marginRight: "10px" }}
                      onClick={() => handleResumeOrder()}
                    >
                      {resuming ? "Resuming…" : "Resume order"}
                    </Button>
                  )}
                  <Button
                    id="cancel_cta"
                    raised
                    disabled={loading}
                    className="cart-module-button-cancel"
                    onClick={() => {
                      exitScreen();
                    }}
                  >
                    {"Cancel"}
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <br />
        {initialCartData?.id > 0 && (
          <>
            <CartIdDetailsSection cart={initialCartData} />
            <br />
          </>
        )}
        <UserDetailsSection
          loading={loading}
          patientIdList={patientIdList}
          setPatientIdList={setPatientIdList}
          patientDetails={patientDetails}
          setPatientDetails={selectPatient}
          accountList={accountList}
          setAccountList={setAccountList}
          accountSelected={accountSelected}
          setAccountSelected={setAccountSelected}
          planList={planList}
          setPlanList={setPlanList}
          planSelected={planSelected}
          setPlanSelected={(plan) => {
            // A plan the operator picks supersedes the note about the cart's original one.
            setPlanError(null);
            setPlanSelected(plan);
          }}
          planError={planError}
          serviceTypeList={serviceTypeList}
          setServiceTypeList={setServiceTypeList}
          serviceTypeSelected={serviceTypeSelected}
          setServiceTypeSelected={setServiceTypeSelected}
          serviceListToShow={serviceListToShow}
          serviceSelected={serviceSelected}
          setServiceSelected={setServiceSelected}
          groupServiceError={groupServiceError}
          familyMemberList={familyMemberList}
          setFamilyMemberList={setFamilyMemberList}
          selectedFamilyMember={selectedFamilyMember}
          setSelectedFamilyMember={setSelectedFamilyMember}
          walletBlockedForMember={walletBlockedForMember}
          walletBlockedMessage={walletBlockedMessage}
          relationsList={relationsList}
          setRelationsList={setRelationsList}
          setPatientInfo={setPatientInfo}
          setUpdatePatientInfoDialog={setUpdatePatientInfoDialog}
          setPatientContactNumber={setPatientContactNumber}
          handlePidSearch={handlePidSearch}
          resetValues={resetValues}
          confirmUpstreamChange={confirmUpstreamChange}
          isDOBEmpty={isDOBEmpty}
          isEmailEmpty={isEmailEmpty}
          getAgeFromDob={getAgeFromDob}
          addressList={addressList}
          addressLoading={addressLoading}
          addressCheckLoading={addressCheckLoading}
          // The only serviceability signal the address field shows. Set solely by a live
          // /service/check — the cart's stored addressNotServiceable flag is not surfaced,
          // since the pending-review re-check re-asks the same question against current
          // coverage and its answer is the one worth acting on.
          addressServiceable={addressServiceable}
          addressSelected={addressSelected}
          setAddressSelected={setAddressSelected}
          getPatientAddress={getPatientAddress}
          handleAddressSelectWithValidation={handleAddressSelectWithValidation}
          // Covers this section entirely: a read-only cart is never a draft, so
          // lockIdentityFields is already true for it.
          lockIdentityFields={lockIdentityFields}
          // Only "Add New" (CREATE) starts without a cart, so it is the only mode where the
          // operator chooses who the cart is for. EDIT-DRAFT / VERIFY / VIEW-ONLY are all opened
          // against a cart id that arrives as a prop and cannot be reset, so the patient there
          // is fixed by definition.
          canPickPatient={mode === "CREATE"}
        />
        <br />
        <DocCartView
          // DocCartView owns local state the parent cannot reach (the test-search box, the
          // test-details dialog). Re-keying on the patient remounts it, so none of it survives
          // a patient switch. Safe here — unlike the screen itself, this child holds no part of
          // the patient selection, so remounting it cannot erase the value the key derives from.
          key={patientDetails?.id ?? "none"}
          disabled={!isDocCartEnabled}
          readOnly={isCartReadOnly}
          // Same resolution order the save/approve handlers use: the fetched cart wins, then the
          // id this screen was opened with, then one just created. Only rendered when readOnly.
          cartId={initialCartData?.id ?? props.data?.cartId ?? createdCartId}
          cartItems={cartItems}
          cartConfirmed={cartConfirmed}
          cartLoading={cartLoading}
          documentsList={documentsList}
          selectedDocument={selectedDocument}
          providers={providers}
          selectedProvider={selectedProvider}
          addressSelected={addressSelected}
          onUploadDocument={handleUploadDocument}
          onSelectDocument={handleSelectDocument}
          onDeleteDocument={handleDeleteDocument}
          onAddToCart={handleAddToCart}
          onRemoveFromCart={handleRemoveFromCart}
          onConfirmCart={handleConfirmCart}
          onModifyCart={handleModifyCart}
          onBookAppointment={handleBookAppointment}
          onSelectProvider={handleProviderChange}
          cartDashboardUtils={cartDashboardUtils}
          docToken={docToken}
          planId={planSelected?.planId}
          patientId={patientDetails?.id}
          groupServiceId={groupServiceId}
          planWalletIncluded={planWalletIncluded}
          walletBlockedForMember={walletBlockedForMember}
          priceRows={priceRows}
          priceTotal={priceTotal}
        />
        <br />
        {cartEventHistory.length > 0 && (
          <PaymentDetailsSection eventHistory={cartEventHistory} />
        )}
        {openSelectDateSlot && (
          <SelectDateSlotSection
            openSelectDateSlot={openSelectDateSlot}
            setOpenSelectDateSlot={setOpenSelectDateSlot}
            slotData={slotData}
            selectedDate={selectedDate}
            selectedSlot={selectedSlot}
            onConfirm={handleSlotConfirm}
            requestedSlot={
              initialCartData?.selectedSlotDate &&
              !String(initialCartData.selectedSlotDate).startsWith("0001")
                ? {
                    date: initialCartData.selectedSlotDate,
                    time: initialCartData.selectedSlotTime,
                    id: initialCartData.selectedSlotId,
                  }
                : null
            }
            showRequestedBanner={mode === "VERIFY"}
            autoSelectFirstAvailable={
              mode === "CREATE" || mode === "EDIT-DRAFT"
            }
          />
        )}
        {showCartPaymentDialog && (
          <CartPaymentDetailsDialog
            visible={showCartPaymentDialog}
            onClose={() => setShowCartPaymentDialog(false)}
            data={cartPaymentPreview}
            onContinue={handleCartPaymentContinue}
          />
        )}
        {showMarkOnHoldDialog && initialCartData?.id != null && (
          <MarkOnHoldDialog
            visible={showMarkOnHoldDialog}
            cartId={initialCartData.id}
            onClose={() => setShowMarkOnHoldDialog(false)}
            onSuccess={(updatedCart) => {
              // Reflect the new status on the screen so the action buttons
              // hide immediately; swap dialogs in the same paint.
              if (updatedCart) {
                setInitialCartData((prev) =>
                  prev ? { ...prev, ...updatedCart } : updatedCart,
                );
              } else {
                setInitialCartData((prev) =>
                  prev ? { ...prev, status: CART_STATUS_ON_HOLD } : prev,
                );
              }
              setShowMarkOnHoldDialog(false);
              setShowMarkOnHoldSuccessDialog(true);
            }}
          />
        )}
        {showMarkOnHoldSuccessDialog && initialCartData?.id != null && (
          <MarkOnHoldSuccessDialog
            visible={showMarkOnHoldSuccessDialog}
            cartId={initialCartData.id}
            onResumed={(updatedCart) => {
              if (updatedCart) {
                setInitialCartData((prev) =>
                  prev ? { ...prev, ...updatedCart } : updatedCart,
                );
              } else {
                setInitialCartData((prev) =>
                  prev ? { ...prev, status: CART_STATUS_PENDING_REVIEW } : prev,
                );
              }
              setShowMarkOnHoldSuccessDialog(false);
            }}
            onDone={() => {
              // Done returns the reviewer to the cart verification dashboard
              // with a fresh fetch — the listing card for this cart should now
              // show "On hold". `resetDashboard` bumps the dashboard's key in
              // index.js so it remounts and re-runs handleGetAllCarts.
              setShowMarkOnHoldSuccessDialog(false);
              if (typeof props.resetDashboard === "function") {
                props.resetDashboard();
              }
              exitScreen();
            }}
          />
        )}
        {showRejectOrderDialog && initialCartData?.id != null && (
          <RejectOrderDialog
            visible={showRejectOrderDialog}
            cartId={initialCartData.id}
            onClose={() => setShowRejectOrderDialog(false)}
            onSuccess={(updatedCart) => {
              // Mirror the optimistic-status update used by the hold flow so
              // the action buttons hide immediately even before refresh.
              if (updatedCart && typeof updatedCart === "object") {
                setInitialCartData((prev) =>
                  prev
                    ? { ...prev, ...updatedCart, status: CART_STATUS_REJECTED }
                    : { ...updatedCart, status: CART_STATUS_REJECTED },
                );
              } else {
                setInitialCartData((prev) =>
                  prev ? { ...prev, status: CART_STATUS_REJECTED } : prev,
                );
              }
              setShowRejectOrderDialog(false);
              setShowRejectOrderSuccessDialog(true);
            }}
          />
        )}
        {showRejectOrderSuccessDialog && initialCartData?.id != null && (
          <RejectOrderSuccessDialog
            visible={showRejectOrderSuccessDialog}
            onReorder={() => {
              // Copy this rejected cart onto the patient's DRAFT and open it as a
              // newly created cart (EDIT-DRAFT) with all details pre-filled.
              //
              // Close this dialog FIRST: handleReorder may need to open the "replace the
              // patient's existing draft?" confirm, and this one is `modal`, so stacking
              // them would trap the operator behind it. handleReorder reads
              // showRejectOrderSuccessDialog from the current render (still true here) and
              // re-opens it if they cancel or the write fails.
              setShowRejectOrderSuccessDialog(false);
              handleReorder();
            }}
            onDone={() => {
              // Done returns to the cart verification dashboard with a fresh
              // fetch so the row for this cart now shows "Rejected".
              setShowRejectOrderSuccessDialog(false);
              if (typeof props.resetDashboard === "function") {
                props.resetDashboard();
              }
              exitScreen();
            }}
          />
        )}
        {showCartPaymentLinkDialog && (
          <CartPaymentLinkDialog
            visible={showCartPaymentLinkDialog}
            onClose={() => setShowCartPaymentLinkDialog(false)}
            preview={cartPaymentPreview}
            cartId={initialCartData?.id ?? props.data?.cartId ?? createdCartId}
            props={props}
            profileDetails={patientDetails}
            onApproved={props.resetDashboardReload}
          />
        )}
        {updatePatientInfoDialog && (
          <DialogContainer
            id="appointment-update-patient-info-dialog"
            visible={updatePatientInfoDialog}
            focusOnMount={false}
            onHide={() => {
              !loadingProfileUpdate && closePatientInfoDialog();
              setSelectedFamilyMember(null);
            }}
            width={"600px"}
            autosizeContent={true}
            // height="320px"
            style={{ maxHeight: "100vh", overflow: "auto" }}
            dialogStyle={{ borderRadius: "10px" }}
          >
            <div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ marginTop: "5px" }}>
                  <h3>Update missing profile details</h3>
                </div>
                <div>
                  <Button
                    raised
                    disabled={loadingProfileUpdate}
                    className={
                      loadingProfileUpdate
                        ? "navigo-module-button-save-disabled"
                        : "navigo-module-button-save-enabled"
                    }
                    onClick={() => {
                      updatePatientInfo(patientInfo);
                    }}
                  >
                    {"Save"}
                  </Button>
                </div>
              </div>
              <br />
              {patientInfo && (
                <>
                  <Row>
                    <Col xs={12} sm={6} md={6} lg={6}>
                      <div className="navigo-module-create-service-field-container">
                        <div className="navigo-module-label">{`User name`}</div>
                        <div>
                          <TextField
                            value={
                              patientInfo
                                ? `${patientInfo.firstName} ${patientInfo.lastName}`
                                : ""
                            }
                            lineDirection="left"
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  {isDOBEmpty(patientInfo) && (
                    <>
                      <Row>
                        <Col xs={12} sm={6} md={6} lg={6}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label">
                              {`Date of birth`}
                              <label className="navigo-module-label-red">
                                *
                              </label>
                            </div>
                            <div style={{ paddingTop: "10px" }}>
                              <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                  style={{ width: "100%" }}
                                  value={newDob}
                                  onChange={(date) => {
                                    setNewDob(date);
                                  }}
                                  autoOk={true}
                                  className="navigo-module-appointment-datepicker"
                                  format="DD MMM YYYY"
                                  placeholder="DD MMM YYYY"
                                  keyboardIcon={
                                    <FontIcon>calendar_month</FontIcon>
                                  }
                                  variant="inline"
                                  minDate={moment().subtract(100, "years")}
                                  maxDate={moment()}
                                />
                              </MuiPickersUtilsProvider>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                    </>
                  )}
                  {isEmailEmpty(patientInfo) && (
                    <>
                      <Row>
                        <Col xs={12} sm={6} md={6} lg={6}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label">
                              {`Email Id`}
                            </div>
                            <div>
                              <TextField
                                value={newEmail}
                                lineDirection="left"
                                onChange={(e) => {
                                  if (e.length <= 50) {
                                    setNewEmail(e.trim());
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                    </>
                  )}
                </>
              )}
            </div>
          </DialogContainer>
        )}
        <LocationSearchDialog
          dialogState={addrEditDialogState}
          setDialogState={addrEditSetDialogState}
          closeDialog={addrEditCloseDialog}
        />
        <AddressFlowDialog
          flowState={addrFlowState}
          setFlowState={setAddrFlowState}
          closeFlow={closeAddrFlow}
          openLocationDialog={addrEditOpenLocationDialog}
          patientId={patientDetails?.id}
        />
        {/* House-style confirm dialog for destructive upstream changes (warn-then-proceed). */}
        <ConfirmDialog />
      </div>
    </>
  );
};

export default PrescribedDiagnosticsScreen;
